<template>
  <div class="page-container user-phoneNumber">
    <div class="header">
      <span style="display: flex;align-items: center">
        <i style="margin-right: 10px;">电话</i>
        <span v-if="seatType == 1" style="color:#aaa;font-size: 12px">（状态：{{ workBenchCallStatusText }}）</span>
        <div v-if="seatType == 2 && huaweiCalling">
          <el-button @click="hangUpHuaweiCall(true)" size="mini" type="success">接通结束</el-button>
          <el-button @click="hangUpHuaweiCall(false)" size="mini" type="danger">未接通结束</el-button>
        </div>
      </span>

      <div class="phone-button">
        <div v-if="!$route.query.aliLogin" @click="addHandle" class="icon-addConnect">
          <i><img src="./img/矩形@2x.png" alt=""></i>
          <span>新增联系人</span>
        </div>
        <div v-if="!$route.query.aliLogin" class="select-message">
          <el-select @change="getSMSDtail(smsSelect)" style="width: 35%" :size="'mini'" v-model="smsSelect"
            placeholder="请选择短信模板">
            <el-option v-for="item in smsList" :key="item.smsCode" :label="item.smsTitle" :value="item.smsCode">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <!--    <div class="call-item">-->
    <div v-if="isCalling" class="call-item">
      <!--<el-button v-if="!isCalling" type="primary" class="item btn" @click="calling" icon="el-icon-phone">自动拨号-->
      <!--</el-button>-->
      <div class="hang-up">
        <div style="margin-left: 15px;" v-text="`通话时长 ${secondText()}`"></div>
        <div style="margin-right: 15px;">
          <el-button v-if="patientData.isRecordingSplit" type="primary" @click="cutTimeHandler">录音切换</el-button>
          <i :class="{ 'callStatus': true, 'calling': callStatus == '响铃中', 'connect': callStatus == '已接通' }">{{
            callStatus
          }}</i>
          <!--          通话时长：{{cutTime}} 最近一次切割时长{{ cutTimeTemp }}-->
          <el-button :disabled="hangupDisabled" type="danger" @click="hangUp">挂断</el-button>
          <!--<el-button v-if="isCallHold" type="primary" @click="callHold">通话保持</el-button>-->
          <!--<el-button v-else type="primary" @click="callRetrieve">通话取回</el-button>-->
        </div>
      </div>
      <!--<div v-else>-->
      <!--<div class="item btn" @click="hangUp">挂断</div>-->
      <!--<div v-if="isCallHold" class="item btn" @click="callHold">通话保持</div>-->
      <!--<div v-else class="item btn" @click="callRetrieve">通话取回</div>-->
      <!--</div>-->
    </div>
    <div v-if="showAudio" class="audio-container">
      <i @click="showAudio = false" class="el-icon el-icon-close close"></i>
      <vue-audio-player :permission="currentUserId == userid" :isRecordingSplit="patientData.isRecordingSplit"
        v-if="audio && !isCalling" :splitPoint="splitPoint" ref="audio" :src="audio"></vue-audio-player>
    </div>
    <!--<div class="header">-->
    <!--<el-checkbox style="margin-left: 15px;" v-model="followupModeChecked">仅电话随访</el-checkbox>-->
    <!--</div>-->
    <div class="user-list">
      <!-- 发送短信 -->
      <template v-if="isModel === 'beMessage'">
        <div v-loading="item.showLoading" class="phoneList" v-for="(item, index) in patientList" :key="index"
          :class="{ 'lastCall': currentCallNumber === item.phoneNumber }"
          :style="(showGray && item.phoneLabel !== '仅随访该号码') ? 'background:rgba(0,0,0,.1);' : 'background:#fff;'">
          <div class="user_tel_box">
            <div class="user_tel_base">
              <span v-if="item.relationshipLevel"
                style="color: #248cfa;font-size: 12px;text-align: center; border: 1px solid #248cfa;border-radius: 50px;width: 20px;height: 20px;line-height: 20px">{{
                  item.relationshipLevel }}</span>
              <span v-text="`${item.phoneNumberStar}`" class="phone-number"
                @click="manualCall(item.phoneNumber, item.id, item)"></span>
              <span style="font-size: 10px">{{ item.belongAddress}}</span>
              <span style="display:flex;align-items: center" v-if="item.isAddWeChat">
                <img style="width: 16px;height: 16px;" src="./img/wechat.png" alt="">
              </span>
              <span class="copy-icon">
                <i @click="copyToClipboard(item.phoneNumber)" class=" el-icon-copy-document"></i>
              </span>
              <span>{{ item.contactName }}</span>
              <el-popover placement="bottom" width="255" trigger="click">
                <div class="category">
                  <div class="category-radio-group">
                    <el-radio v-model="radioCheck" label="无标签" @change="categoryCheckChange($event, item, true)"
                      @click.native="closePop(item)">
                      <div class="category-item">
                        <img src="./img/notag.png" alt="logo" style="width: 20px;cursor: pointer;" />
                        <div class="category-item-text">无标签</div>
                        <img v-if="!radioCheck || radioCheck == '无标签'" src="./img/check2.png" alt="logo"
                          style="width: 20px;" />
                      </div>
                    </el-radio>
                    <el-radio v-model="radioCheck" label="仅随访该号码" @change="categoryCheckChange($event, item, true)"
                      @click.native="closePop(item)">
                      <div class="category-item" style="color:#B40C0C;">
                        <span
                          style="border: 1px solid #B40C0C;border-radius: 4px;width:28px;height:28px;line-height:28px;padding:0px 7px;">仅</span>
                        <div class="category-item-text">仅随访该号码</div>
                        <img v-if="radioCheck == '仅随访该号码'" src="./img/check2.png" alt="logo" style="width: 20px;" />
                      </div>
                    </el-radio>
                    <el-radio v-model="radioCheck" :label="customLabel" :value="item.id"
                      @change="categoryCheckChange($event, item, true)">
                      <div class="category-item">
                        <span
                          style="border: 1px solid;border-radius: 4px;text-align: center;width:28px;height:28px;line-height:28px;margin-right: 5px;">自</span>
                        <el-input class="category-item-text" size="mini" v-model="customLabel" placeholder="自定义标签"
                          @focus="inputFocus" @change="categoryCheckChange($event, item, true)"></el-input>
                        <img v-if="radioCheck && radioCheck == customLabel" src="./img/check2.png" alt="logo"
                          style="width: 20px;" @click.native="closePop(item)" />
                      </div>
                    </el-radio>
                  </div>
                </div>
                <div slot="reference" v-show="!$route.query.aliLogin" class="category-slot">
                  <el-tooltip style="margin: 0 5px;" :content="item.phoneLabel == '' ? '无标签' : item.phoneLabel"
                    placement="bottom-start" effect="light" :enterable="false">
                    <span v-if="item.phoneLabel == '' || item.phoneLabel == '无标签'" style="padding: 5px 2px 0px 2px;">
                      <img src="./img/notag.png" alt="logo" @click="getPhoneLabelList(item)"
                        style="width: 20px;cursor: pointer;" />
                    </span>
                    <span v-else-if="item.phoneLabel == '仅随访该号码'" @click="getPhoneLabelList(item)"
                      style="border: 1px solid #B40C0C;border-radius: 4px;padding: 2px 4px; color:#B40C0C;">仅</span>
                    <span v-else @click="getPhoneLabelList(item, index)"
                      style="border: 1px solid;border-radius: 4px; padding: 2px 4px;">{{
                        item.phoneLabel ? item.phoneLabel.split('')[0] : ''
                      }}</span>
                  </el-tooltip>
                </div>
              </el-popover>
              <!-- <span v-if="!item.isLast" class="phone-number" v-show="item.lastCallState"
                    style="margin-left: 8px;color: #666;">-{{ getCodeName(item.lastCallState) }}</span>
                    
              <el-select :disabled="$route.query.aliLogin ? true : false"
                         @change="relationCallStatechangeHandler(item,2)"
                         :class="{'bd': true,'error': statusError}" style="width: 90px" v-else
                         size="mini" v-model="item.lastCallState" placeholder="呼叫状态">
                <el-option v-for="(phone ,idx) in phoneCallStateList" :key="idx" :value="phone.code"
                           :label="phone.codeName"></el-option>
              </el-select> -->

              <!-- 联系状态 -->
              <!-- <span v-if="!item.isLast" class="phone-number" v-show="item.contactStatus"
                    style="margin-left: 8px;color: #666;">-{{ getContactStatusName(item.contactStatus) }}</span> -->
              <el-select :disabled="$route.query.aliLogin || item.contactStatus == '初始化' ? true : false"
                @change="changeContactStatus(item)" style="width: 120px" size="mini" v-model="item.contactStatus"
                placeholder="联系状态">
                <el-option v-for="(phone, idx) in contactStatusList" :key="idx" :value="phone.value"
                  :label="phone.label"></el-option>
              </el-select>
              <!-- 联系情况 -->
              <!-- <span v-if="!item.isLast" class="phone-number" 
                    style="margin-left: 8px;color: #666;">-{{ getContactInformationName(item.contactInformation) }}</span> -->
              <el-select :disabled="$route.query.aliLogin || item.contactInformation == '初始化' ? true : false"
                style="width: 100px;" @change="changeContactInformation(item)" size="mini"
                v-model="item.contactInformation" placeholder="联系情况">
                <el-option v-for="(phone, idx) in contactInformationList" :key="idx" :value="phone.value"
                  :label="phone.label" :disabled="isSituationDisabledRow(phone.value, item.contactStatus)"></el-option>
              </el-select>


              <!-- <span>{{ item.relationshipName}}</span> -->
              <el-select @change="changeHandlerconnectEdit(item, 2)" size="mini" v-model="item.relationshipName"
                placeholder="联系人关系" style="width: 80px;" filterable>
                <el-option v-for="item in connectListAll" :key="item.id" :value="item.relationship"
                  :label="item.relationship"></el-option>
              </el-select>

              <!-- <el-select v-model="item.cooperateScore" size="mini" style="width:60px;margin-left:10px;"
                         placeholder="请选择配合度" @change="confirmEditHandler(item)">
                <el-option value="1" label="1"></el-option>
                <el-option value="2" label="2"></el-option>
                <el-option value="3" label="3"></el-option>
                <el-option value="0" label="0"></el-option>
              </el-select>
              分 -->
              <!-- <span>{{ item.cooperateScore}}分</span> -->
            </div>
            <div class="user-tel-state">
              <template v-if="nextCallNumber !== item.phoneNumber || !isCalling">

                <span v-show="!$route.query.aliLogin" class="icon-span"
                  @click="manualCall(item.phoneNumber, item.id, item)" title="点击拨号">
                  <img src="./img/phone.png" alt="">
                </span>
                <span class="icon-span" @click="callHistoryClickHandler(item)" title="查看通话记录">
                  <img src="./img/history.png" alt="">
                </span>
                <span v-if="item.isSendSMS && !$route.query.aliLogin" @click="sendMessageHandle(item)" class="icon-span"
                  title="发送短信">
                  <img src="./img/message01.png" alt="">
                </span>
                <span v-else class="icon-span" style="cursor: not-allowed;">
                  <img src="./img/message.png" alt="">
                </span>
                <span class="icon-span" @click="editContactClickHandler(item)" title="编辑">
                  <img src="./img/edit2.png" alt="">
                </span>
              </template>

              <template v-else-if="isCalling && nextCallNumber === item.phoneNumber">
                <span v-text="'拨号中'" class="calling-color"></span>
              </template>
            </div>

          </div>
          <div v-if="item.showAudio" class="audio-list">
            <div class="audio-list-item" v-for="(it, ind) in item.phoneRecordInfoList" :key="ind">
              <div style="display: flex;align-items: center;flex: 1;">
                <div style="margin-right: 15px;display: inline-block;min-width: 100px">{{
                  getCodeName(it.callState)
                }}</div>
                <div style="width: 16%;margin-right: 6px;">{{ getContactStatusName(it.contactStatus) }}</div>
                <div style="width: 16%;margin-right: 6px;">{{ getContactInformationName(it.contactInformation) }}</div>

                <div>{{ it.createTime }}</div>
                <div style="margin-left: 25px;">{{ it.seatName }}</div>
              </div>
              <div>
                <el-button v-if="it.isRecording || it.recording"
                  @click="getAudio(it.contactId, it.splitPoint, it.id, it.seatId)" size="mini" type="text">听录音
                </el-button>
                <el-button
                  :style="{ color: new Date().getTime() - new Date(it.createTime).getTime() < 40000 ? '#e57979' : '#d8d8d8' }"
                  v-else @click="refreshAudioList(item)"
                  :disabled="new Date().getTime() - new Date(it.createTime).getTime() > 40000" size="mini" type="text">
                  {{
                    new Date().getTime() - new Date(it.createTime).getTime() < 40000 ? '暂无录音（点击刷新）' : '暂无录音' }}
                    </el-button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="isModel === 'messageing'">
        <el-checkbox-group v-model="checkPhoneList" @change="handleChangeUser" class="message-list">
          <el-checkbox v-for="(item, index) in patientList" :label="item.id" :key="index" :disabled="item.isBeenSend">
            <p class="users">
              <span v-text="`${item.relationshipName}`"></span>
              <span v-text="`(${item.phoneNumberStar})`"></span>
            </p>
          </el-checkbox>
        </el-checkbox-group>
      </template>
    </div>
    <el-dialog width="52%" :visible.sync="phoneDialogVisible">
      <template slot="title">
        <span v-text="operator"></span>
      </template>
      <div class="contact_info" v-for="(contact, contact_index) in addContactInfo" :key="contact_index">
        <div class="contact_info_item">
          <el-select class="" v-model="contact.phoneType" placeholder="联系方式" clearable
            @change="phoneTypeChange(contact)" style="width: 170px">
            <el-option :value="true" label="手机号码"></el-option>
            <el-option :value="false" label="座机号码"></el-option>
          </el-select>
          <div v-if="!contact.phoneType" style="display: flex; align-items: center;">
            <el-input v-model="contact.code" @input="changeInput" @change="checkPhoneNumber(contact)" clearable
              type="text" placeholder="区号" style="width: 90px"></el-input>
            <el-input placeholder="电话号码" clearable v-model="contact.phoneNumber" @change="checkPhoneNumber(contact)"
              style="width: 150px">
            </el-input>
          </div>
          <el-input v-else v-model="contact.phoneNumber" @change="checkPhoneNumber(contact)" type="text" clearable
            placeholder="手机号码" style="width: 240px"></el-input>

          <el-input v-model="contact.contactName" placeholder="联系人姓名" clearable filterable
            style="width: 180px"></el-input>
          <el-select @change="changeHandlerconnectAdd(contact)" v-model="contact.relationshipName" placeholder="联系人关系"
            clearable filterable>
            <el-option v-for="item in connectListAll" :key="item.id" :value="item.relationship"
              :label="item.relationship"></el-option>
          </el-select>
          <el-select v-model="contact.relationshipLevel" placeholder="联系人等级" clearable>
            <el-option v-for="(item, idx) in relationshipLevelList" :label="item.label" :value="item.value"
              :key="idx"></el-option>
          </el-select>

          <el-select v-model="contact.cooperateScore" placeholder="配合度" clearable>
            <el-option value="1" label="1"></el-option>
            <el-option value="2" label="2"></el-option>
            <el-option value="3" label="3"></el-option>
            <el-option value="0" label="0"></el-option>
          </el-select>
          <span>
            <span v-if="addContactInfo.length > 1" @click="deleteContactHandle(contact_index)"
              class="phone_edit_span"><i class="el-icon-delete-solid"></i></span>
          </span>
        </div>
      </div>

      <div style="text-align: right;margin-top: 25px;">
        <el-button size="medium" type="success" @click="addContactHandle()">新增</el-button>
        <el-button size="medium" type="primary" @click="saveHandle()">保存</el-button>
      </div>
    </el-dialog>
    <!-- 拨打完成的状态 -->
    <el-dialog :visible.sync="callStatusVisible" class="call-status" :show-close="isShowNextTimeClose"
      :close-on-press-escape="isCloseEscape" :close-on-click-modal="closeModal">

      <div class="" style="font-weight: bold;font-size:18px;text-align:center;">{{ callSuccess ? '接通' : '未接通' }}
      </div>
      <!-- 电话接通的情况 -->
      <div class="call-status-btn-wrapper" v-if="callSuccess">
        <div class="phone-item">
          <span>联系状态：</span>
          <div class="status-options">
            <div v-for="(status, index) in contactStatusList" :key="'status-' + index" :class="['status-item', {
              active: selectedStatus === status.value,
              disabled: isStatusDisabled(status.value)
            }]" @click="!isStatusDisabled(status.value) && selectStatus(status.value)">
              {{ status.label }}
            </div>
          </div>
        </div>
        <div class="phone-item">
          <span>联系情况：</span>
          <div class="status-options">
            <div v-for="(situation, index) in contactInformationList" :key="'situation-' + index" :class="['status-item', {
              active: selectedSituation === situation.value,
              disabled: isSituationDisabled(situation.value)
            }]" @click="!isSituationDisabled(situation.value) && selectSituation(situation.value)">
              {{ situation.label }}
            </div>
          </div>
        </div>
        <div class="phone-item" v-if="this.selectedStatus == 2" style="align-items: flex-start;">
          <span style="color: #fff;">稍后拨打:</span>
          <div class="status-options">
            <el-form center :rules="nextTimeFormRule" :model="nextTimeForm" ref="nextTimeForm">
              <el-form-item label="稍后拨打时间" prop="nextCallTime">
                <el-date-picker v-model="nextTimeForm.nextCallTime" :value-format="'yyyy-MM-dd HH:mm:ss'"
                  type="datetime" placeholder="选择日期时间" :picker-options="pickerOptions" @change="timeTip">
                </el-date-picker>
                <el-button style="margin-left: 20px;" @click="afterCallConfirm('nextTimeForm')"
                  type="primary">确定</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- <div class="phone-item">
          <span>稍后拨打：</span>
          <el-button @click="callLaterHandler">稍后拨打</el-button>
        </div>
        <div class="phone-item">
          <span>接通：</span>
          <el-button @click="afterCallHandle(6)">挂断(接通)</el-button>
          <el-button @click="afterCallHandle(11 ,'refuseFinsh')">拒绝随访</el-button>
          <el-button @click="afterCallHandle(15)">沟通不畅</el-button>
          <el-button @click="afterCallHandle(13)">错号</el-button>
          <el-button @click="afterCallHandle(14)">不知情</el-button>
        </div>
        <div class="phone-item">
          <span>完成：</span>
          <el-button @click="afterCallHandle(4,'successFinsh')">完成电话随访接听</el-button>
        </div> -->
      </div>

      <!-- <div class="call-status-btn-wrapper" v-else>
        <div class="phone-item">
          <span>手机服务：</span>
          <el-button @click="afterCallHandle(12)">空号</el-button>
          <el-button @click="afterCallHandle(9)">停机</el-button>
          <el-button @click="afterCallHandle(10)">关机</el-button>
        </div>
        <div class="phone-item">
          <span>未接通：</span>
          <el-button @click="afterCallHandle(8)">挂断（未接通）</el-button>
          <el-button @click="afterCallHandle(7)">无人接听</el-button>
        </div>
      </div> -->
    </el-dialog>
    <!-- 稍后再拨打 -->
    <el-dialog :visible.sync="callNextTimeVisible" :append-to-body="true" center>
      <el-form center :rules="nextTimeFormRule" :model="nextTimeForm" ref="nextTimeForm">
        <el-form-item label="稍后拨打时间" prop="nextCallTime">
          <el-date-picker v-model="nextTimeForm.nextCallTime" :value-format="'yyyy-MM-dd HH:mm:ss'" type="datetime"
            placeholder="选择日期时间" :picker-options="pickerOptions" @change="timeTip">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <!-- <el-button @click="beforeCallHandle(1)" type="primary">确定</el-button> -->
          <el-button @click="afterCallConfirm" type="primary">确定</el-button>
          <el-button @click="cancelNextTime">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :title="`是否要给${messageTarget.phoneNumberStar}发送短信`" :visible.sync="messageDialogVisible"
      class="sms-record-dialog" width="30%">
      <div style="margin-bottom: 20px;">
        <el-button size="mini" @click="sonSmsSelectHandler(item)" :type="(selectSonSms.id && selectSonSms.id == item.id) ? 'primary': ''" v-for="(item) in smsSonList" :key="item.id">{{ item.smsTitle }}</el-button>
      </div>
      <p>{{ selectSonSms&&selectSonSms.id ? selectSonSms.smsContent : smsDetail }}</p>
      <div style="margin-top: 20px;">
        <div style="font-size: 15px;color: #000;margin-bottom: 10px;">短信发送记录：</div>
        <el-table :data="smsSendRecordLists" class="sms-record-table" size="mini">
          <el-table-column property="crateTime" label="发送时间" align="center"></el-table-column>
          <el-table-column property="templateTitle" label="短信标题" align="center"></el-table-column>
          <el-table-column property="sendStatus" label="结果" align="center" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.sendStatus == '失败'">
                <el-popover placement="left" width="200" trigger="click">
                  <div style="font-size: 13px;">失败原因：<br>{{ scope.row.failReason }}</div>
                  <span slot="reference" style="text-align: left;color:#f00; cursor: pointer;"><i
                      class="el-icon-warning"></i>{{ scope.row.sendStatus }}</span>
                </el-popover>
              </div>
              <div v-else style="color:#409eff;"><i class="el-icon-success"></i>{{ scope.row.sendStatus }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="messageDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendMessage" :loading="sendMessageLoading">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑联系方式" :visible.sync="editDialogVisible" width="50%">
      <div class="contact_info">
        <div class="contact_info_item">
          <el-select class="" v-model="patientListItem.phoneType" placeholder="联系方式" clearable
            @change="phoneTypeChange(patientListItem)" disabled>
            <el-option :value="true" label="手机号码"></el-option>
            <el-option :value="false" label="座机号码"></el-option>
          </el-select>
          <div v-if="!patientListItem.phoneType">
            <el-input v-model="patientListItem.code" @input="changeInput" type="text" placeholder="区号"
              style="width: 80px" clearable disabled></el-input>
            <el-input placeholder="电话号码" v-model="patientListItem.phoneNumber" clearable disabled style="width: 160px">
            </el-input>
          </div>
          <el-input v-else v-model="patientListItem.phoneNumber" clearable type="text" disabled placeholder="手机号码"
            style="width: 240px"></el-input>

          <el-input v-model="patientListItem.contactName" placeholder="联系人姓名" style="width: 200px"></el-input>
          <el-select @change="changeHandlerconnectEdit(patientListItem, 1)" v-model="patientListItem.relationshipName"
            placeholder="请选择联系人关系" filterable clearable>
            <el-option v-for="item in connectListAll" :key="item.id" :value="item.relationship"
              :label="item.relationship"></el-option>
          </el-select>
          <el-select v-model="patientListItem.relationshipLevel" placeholder="请选择联系人等级" clearable>
            <el-option v-for="(item, idx) in relationshipLevelList" :label="item.label" :value="item.value"
              :key="idx"></el-option>
          </el-select>
          <el-select v-model="patientListItem.cooperateScore" placeholder="请选择配合度" clearable>
            <el-option value="1" label="1"></el-option>
            <el-option value="2" label="2"></el-option>
            <el-option value="3" label="3"></el-option>
            <el-option value="0" label="0"></el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmEditHandler(patientListItem, 'update')" type="primary">修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import _ from 'lodash'
import {
  RestNewFollowupCallCenterServiceGetPhoneRecordInfoListByPhoneNumber,
  RestFeedbackOutControllerUpdateRecordList,
  RestNewFollowupCallCenterServiceAddFollowupPatientContactInformation, // 添加患者手机号码
  RestNewFollowupCallCenterServiceUpdateFollowupPatientContactInformation, // 更新患者手机号码
  // RestCallCenterServiceGetPatientPhoneNumberList , // 获取患者电话列表
  RestNewFollowupCallCenterServiceSendingFollowupSms, // 发送短信
  RestNewFollowupCallCenterServiceSendingFollowupSmsTask,//发送短信
  RestNewFollowupCallCenterServiceGetSmsTemplateByCode,//获取短信模板详情
  RestCallCenterServiceGetAllRelationship,  // 获取关系列表
  RestNewFollowupCallCenterServiceUpdatePhoneNumberCallState, //添加本次呼叫状态(是否已失访)
  RestNewFollowupCallCenterServiceUpdateLaterCallFollowupTask,// 稍后拨叫
  RestNewFollowupCallCenterServiceGetDiseaseSmsTemplateList, //获取疾病对于短信列表
  RestNewFollowupCallCenterServiceFirstUpdatePhoneNumberCallState, //第一次保存呼叫记录
  RestFeedbackOutControllerGetRecordList,
  RestNewFollowupCallCenterServiceGetALiRecording,
  RestNewFollowupCallCenterServiceGetSmsTemplateTaskList,
  RestNewFollowupCallCenterServiceAddRecordWaitingTime,//通话时间
  RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfoList, //获取抽查列表
  RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfoList,
  RestNewFollowupCallCenterServiceGetFollowupPatientContactInformationList,
  RestNewFollowupCallCenterServiceGetPhoneLabelList,//获取手机号标签
  RestNewFollowupCallCenterServiceAddOrSelectPhoneLabel, //添加或选择手机号标签
} from "@src/assets/js/api.js";
import errorHandleMixin from '@mixins/errorHandleMixin';
import { mapState, mapGetters, mapMutations } from 'vuex'
import vueAudioPlayer from '../AudioPlayer/vueAplayerN'
import { RestNewFollowupCallCenterServiceGetAllRelationshipLevel } from "../../assets/js/api";

export default {
  name: 'UserPhone',
  data() {
    return {
      huaweiId: {},
      selectSonSms: {id: null,smsDetail: null},
      huaweiCalling: false,
      splitPoint: null,
      connectList: [],
      smsSonList: [],
      connectListAll: [],
      callingNumber: null,
      audioLoading: false,
      callStatus: '正在拨号',
      hangState: true, //能不能挂断
      smsDetail: '',
      messageTarget: {
        phoneNumberStar: ''
      },
      messageDialogVisible: false,
      statusError: false,
      showAudio: false,
      audio: '',
      timer: null,
      callReturnId: null,
      currentContactId: null,
      currentUserId: null,
      recordId: null,
      isCallHold: true,
      intervalTimer: null,
      seconding: 0,
      status: "work",
      followupModeChecked: false,
      smsList: [], //短信列表
      smsSelect: null,
      answerType: 1,
      isCalling: false, //当前是否为 打电话
      callStatusVisible: false, // 播放
      callRecordListVisible: false,
      multipleSelection: [],
      callRecordList: [],//呼叫记录列表
      phoneList: [],
      unconvertPhone: [],
      // 无效
      phoneModel: {
        phoneNumber: '',
        relationshipId: ''
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '明天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', date)
            }
          },
          {
            text: '后天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周之后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date)
            }
          }
        ],
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 3600 * 1000;
        },
      },
      // form -- 电话
      form: {
        contactName: "",
        phoneNumber: "",
        relationshipLevel: "",
        relationshipLevelId: "",
        lastCallState: ""
      },
      seatType: localStorage.getItem('seatType'),
      // form -- 稍后拨打
      nextTimeForm: {
        nextCallTime: ''
      },
      editDialogVisible: false,
      // 再次拨打 dialog
      callNextTimeVisible: false,
      isShowNextTimeClose: false, // show-close
      isCloseEscape: false, // close-on-press-escape 有没有简单刷单的
      closeModal: false, // close-on-click-modal
      showPhoneAdd: false, // 是否显示添加
      dialogType: 'add',
      // dialog --- phone
      phoneDialogVisible: false,
      hangupDisabled: true,
      // 发送短信模式
      isModel: 'beMessage', //  beMessage 即将发送短信模式  messageing
      checkPhoneList: [],
      sendMessageLoading: false,
      // validator
      validatorRule: {
        relationshipName: [
          { required: false, message: '请选择关系', trigger: 'trigger' }
        ],
        contactName: [
          { required: false, message: '请输入姓名', trigger: 'trigger' }
        ],
        phoneType: [
          { required: true, message: '请选择联系方式', trigger: 'trigger' }
        ],
        phoneNumber: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
        ]
      },
      nextTimeFormRule: {
        nextCallTime: [
          { required: true, message: '请填写日期', trigger: 'trigger' },
          { validator: this.nextTimeValidator, trigger: 'trigger' }
        ],
      },
      // 当前 患者信息
      currentRelationPatientInfo: null,
      relationShipList: [], // 关系列表
      patientList: [], // 患者列表
      phoneCallStateList: [
        { code: 1, codeName: '稍后拨打' },
        { code: 2, codeName: '仅随访该号码' },
        { code: 3, codeName: '短信随访成功' },
        { code: 4, codeName: '电话随访成功' },
        { code: 5, codeName: '初始化' },
        { code: 6, codeName: '挂断（接通）' },
        { code: 7, codeName: '无人接听' },
        { code: 8, codeName: '挂断（未接通）' },
        { code: 9, codeName: '停机' },
        { code: 10, codeName: '关机' },
        { code: 11, codeName: '拒随' },
        { code: 15, codeName: '沟通不畅' },
        { code: 12, codeName: '空号' },
        { code: 13, codeName: '错号' },
        { code: 14, codeName: '不知情' },
        { code: 15, codeName: '沟通不畅' }], // 电话状态列表
      radioCheck: null,
      showCheck: {
        check1: false,
        check2: false,
        check3: false,
      },
      customLabel: "",
      selectPhoneLabelId: null,
      categoryPopoverVisible: false,
      callSuccess: false,//是否接通
      testItem: {},
      showGray: false,
      phoneLabelList: [],
      calleePhoneNumber: 'auto',
      concatIDBackUp: "",
      addContactInfo: [{
        phoneType: true,
        phoneNumber: null,
        contactName: null,
        relationshipLevel: null,
        relationshipName: null,
        cooperateScore: null,
        code: null,
        isChecked: false, //联系方式是否校验通过
      }],
      cutTimeInterVal: null,
      cutTime: 0,
      cutTimeTemp: 0,
      patientListItem: {},
      relationshipLevelList: [],
      smsSendRecordLists: [], //短信发送记录

      selectedStatus: null,
      selectedSituation: null,
      contactStatusList: [
        // { label: '初始化', value: 1 },
        { label: '稍后拨打', value: 2 },
        { label: '电话随访成功', value: 3 },
        { label: '电话随访未成功', value: 4 }
      ],
      contactInformationList: [ // 联系情况
        // { label: '初始化', value: 11 },
        { label: '沟通顺畅', value: 12 },
        { label: '拒绝随访', value: 13 },
        { label: '沟通不畅', value: 14 },
        { label: '错号', value: 15 },
        { label: '不知情', value: 16 },
        { label: '无', value: 18 },
        { label: '空号', value: 19 },
        { label: '停机', value: 20 },
        { label: '关机', value: 21 },
      ],
    }
  },
  computed: {
    workBenchCallStatusText() {
      let result = ""
      switch (this.workBenchCallStatus) {
        case 3:
          result = '空闲[可外呼]';
          break
        case 2:
          result = '小休';
          break
        case 1:
          result = '离线[需登录]';
          break
        case 5:
          result = '通话后处理';
          break
        case 8:
          result = '拨号[可挂断]';
          break
        case 10:
          result = '呼出通话[可挂断]';
          break
        case -1:
          result = '未注册';
          break
        case 0:
          result = '注册中';
          break
      }
      return result
    },
    ...mapGetters([
      'patientId',
      'userid',
      'username',
      'phoneStatus',
      'getTaskCenterId',
      "getCallingNumber"
    ]),
    ...mapState([
      'taskId',
      'nextCallNumber',
      'workBenchCallStatus',
      'currentCallNumber',
      'currentCallNumberId',
      'contactId',
      'nextCallNumberId',
      "callObj"
    ]),
    // 新增
    operator() {
      return this.dialogType === 'add' ? '新增联系人' : '编辑联系人'
    },
    uniqueId() {
      return _.uniqueId('relation_')
    },
    taskType() {
      return this.$route.query.taskType && parseInt(this.$route.query.taskType, 10) || ''
    },
    isAbnormal() {
      return this.$route.query.abnormal === 2; //1是正常 2是异常
    }

  },
  created() {
    // 获取 关系列表
    this.getReationShip();
  },
  watch: {
    patientList: {
      handler(val, oldVal) {
        if (val != oldVal) {
          this.followupModeChecked = false
          let temp = val.filter(item => {
            return item.phoneLabel == "仅随访该号码"
          })
          if (temp.length > 0) {
            this.showGray = true
          } else {
            this.showGray = false
          }
        }
      },
      deep: true,
      immediate: true
    },

  },
  components: { vueAudioPlayer },
  mounted() {
    let vm = this;
    // console.log('CODE', window.workbench.getStatusCode().code);
    this.getPhoneNumber()
      .then(res => {
        console.log(res);
        this.calleePhoneNumber = res.retValue == '未查到对应任务坐席信息' ? 'auto' : res.retValue
      })
    window.pubsub && window.pubsub.off('splitAudio').on('splitAudio', (val) => {
      console.log('split');
      this.splitPointHandler(false, val)
    })
    window.pubsub && window.pubsub.off('cancelsplitAudio').on('cancelsplitAudio', (val) => {
      console.log('cancelsplitAudio');
      this.cancellationRecordingSplit()
    })
    window.pubsub && window.pubsub.off('callDialing').on('callDialing', () => {
      console.log('响铃中.....');
      this.$set(this, 'callStatus', '响铃中')
    })
    window.pubsub && window.pubsub.off('call-hang-up').on("call-hang-up", () => {
      console.log('call-hang-up', arguments)
      console.log(2222);
      //挂断时候的操作
      clearInterval(this.cutTimeInterVal)
      this.cutTime = 0
      this.cutTimeTemp = 0
      this.listenHangUp()
    });
    window.pubsub && window.pubsub.off('CallEstablish').on("CallEstablish", () => {
      console.log('通话接通....');
      this.$set(this, 'callStatus', '已接通')
      console.log('CallEstablish--------->', arguments)
      this.callSuccess = true
      let startTime = new Date().getTime()
      this.cutTimeInterVal = setInterval(() => {
        this.updateTimer(startTime)
      }, 1)

    });
    window.pubsub && window.pubsub.off('callOver').on('callOver', () => {
      console.log('call over ', arguments)
      this.$set(this, 'callStatus', '已挂断')
    });
    window.pubsub && window.pubsub.off('isCalling').on('isCalling', function () {
      console.log('isCalling ', arguments)
    });
    window.pubsub && window.pubsub.off('callHangUp').on('callHangUp', function () {
      console.log('user -- phone --- callHangUp ', arguments)
      vm.isCalling = false;
    });
    // 正在打电话
    window.pubsub && window.pubsub.off('calling').on('calling', function () {
      console.log('user -- phone -- calling ', arguments)

      vm.isCalling = true;
    });

    window.pubsub && window.pubsub.off('call-setContactId').on('call-setContactId', (concatID) => {
      if (concatID) {
        console.log(concatID);
        this.setContactId(concatID);
        this.concatIDBackUp = concatID
        localStorage.setItem('concatID', JSON.stringify(concatID))
        console.log('calling  -------------- ', this.nextCallNumber)
        this.beforeCall()
          .then((res) => {
            if (res) {
              // this.getFollowupPatientRecordList(it)
              this.setCallingStatus()
              window.pubsub && window.pubsub.emit('calling');
            } else {
              this.$message.error('缺少contractId')
            }
          })
      } else {
        this.$message.error('未获取到录音ID，请退出后重试~')
        return false
      }
    });
    vm.getSmsList()
    vm.getAllRelationshipLevel()
      .then(res => {
        this.connectListAll = res.retValue.filter(item => item.relationship != '其他')
        this.connectListAll.push({
          id: null,
          level: 3,
          relationship: '其他'
        })
        this.connectList[0] = res.retValue.filter(it => it.level == 1)
        this.connectList[1] = res.retValue.filter(it => it.level == 2)
        this.connectList[2] = res.retValue.filter(it => it.level == 3)
      })
    vm.followupModeChecked = false
    // // 长时间闲置 会 将状态 设置为 小休状态
    // window.pubsub && window.pubsub.off('goRest').on('goRest', () => {
    //     this.status = "rest";
    // });
    // let code = this.getCurrentCode()
    // if (code === 3) {
    //     this.status = 'work'
    // } else if (code === 4) { //小休
    //     this.status = "rest";
    // }
    let temp = vm.patientList.filter(item => {
      return item.phoneLabel == "仅随访该号码"
    })
    if (temp.length > 0) {
      this.showGray = true
    } else {
      this.showGray = false
    }
  },
  props: {
    patientData: {
      type: Object,
      default() {
        return {}
      }
    },
    // isAbnormal:{
    //     type:Boolean,
    // },
  },
  mixins: [errorHandleMixin],
  methods: {
    ...mapMutations(['setNextCallNumber', 'removeContactId', 'removeContactIds', 'setCurrentCallNumber', 'setCurrentCalling', 'setContactSuccessIds', 'setContactId']),
    copyToClipboard(text) {
      navigator.clipboard.writeText(text)
        .then(() => {
          console.log('Text copied to clipboard');
          this.$message.success('复制成功')
        })
        .catch((err) => {
          console.error('Failed to copy text: ', err);
          this.$message.success('复制失败')
        });
    },
    updateTimer(startTime) {
      let currentTime = new Date().getTime(); // 获取当前时间的毫秒数
      let elapsedTime = currentTime - startTime; // 计算经过的时间（毫秒）

      // 将毫秒转换为秒和毫秒部分
      let seconds = Math.floor(elapsedTime / 1000);
      let milliseconds = elapsedTime % 1000;
      this.cutTime = `${seconds}.${milliseconds}`
      // console.log(`经过了 ${seconds} 秒 ${milliseconds} 毫秒`);
    },
    cutTimeHandler() {
      this.cutTimeTemp = this.cutTime
      this.splitPointHandler(true, this.cutTime).then(res => {
        if (res.status == 0) {
          this.$message.success("切换成功")
        }
      })
    },
    async cancellationRecordingSplit() {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceCancellationRecordingSplitPoint',
        params: {
          id: this.callReturnId,
          nowUserId: this.userid,
          followUpTaskId: this.getTaskCenterId,
          followupPatientInfoId: this.patientData.followupPatientId,//后端参数取得followupPatientId 忽略传参参数
          phoneNumber: this.currentRelationPatientInfo.phoneNumber
        }
      })
    },
    async splitPointHandler(isDelay, second) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceUpdateRecordingSplitPoint',
        params: {
          id: this.callReturnId,
          recordingSplitPoint: second || this.cutTime,
          isDelay: isDelay || false,
          nowUserId: this.userid,
          followUpTaskId: this.getTaskCenterId,
          followupPatientInfoId: this.patientData.followupPatientId,//后端参数取得followupPatientId 忽略传参参数
          phoneNumber: this.currentRelationPatientInfo.phoneNumber
        }
      })
    },
    changeHandlerconnectAdd(contact) {
      let list_item = this.connectListAll.find(item => item.relationship == contact.relationshipName)
      contact.relationshipLevel = list_item ? list_item.level : null
      if (list_item) {
        this.relationshipLevelList = [
          { value: 1, label: '一级联系人' },
          { value: 2, label: '二级联系人' },
          { value: 3, label: '三级联系人' },
        ]
      } else {
        this.relationshipLevelList = []
      }
    },
    changeHandlerconnectEdit(contact, type) {
      let list_item = this.connectListAll.find(item => item.relationship == contact.relationshipName)
      contact.relationshipLevel = list_item ? list_item.level : null
      contact.relationshipLevelId = list_item ? list_item.id : null
      if (list_item) {
        this.relationshipLevelList = [
          { value: 1, label: '一级联系人' },
          { value: 2, label: '二级联系人' },
          { value: 3, label: '三级联系人' },
        ]
      } else {
        this.relationshipLevelList = []
      }
      if (type == 2) {// 联系人列表里直接保存编辑
        this.confirmEditHandler(contact)
      }
    },
    rebackVideoAuto() {
      setTimeout(() => {
        this.showLastPhoneList()
          .then(() => {
            let lastCallUser = this.patientList.find(item => item.isLast)
            console.log(lastCallUser);
            let lastReocrd = lastCallUser.phoneRecordInfoList.find(item => item.isRecording)
            let concatId = lastReocrd.contactId
            let splitPoint = lastReocrd.splitPoint
            let id = lastReocrd.id
            console.log(concatId);
            if (concatId) {
              this.getAudio(concatId, splitPoint, id)
            }
          })
      }, 4000)
    },
    //获取外呼号码
    async getPhoneNumber() {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestCallCenterServiceGetPhoneNumber',
        params: {
          taskId: this.getTaskCenterId,
          seatId: this.userid
        }
      })
      return result
    },
    showLastPhoneList() {
      return new Promise(resolve => {
        let lastCallUser = this.patientList.find(item => item.isLast)
        this.callHistoryClickHandler(lastCallUser)
          .then(() => {
            resolve()
          })
      })
    },
    getAudio(concatId, splitPoint, id, userId) {
      this.callReturnId = id || null
      this.currentContactId = concatId || null
      this.currentUserId = userId
      this.audio = ''
      this.getRecordList(concatId)
        .then(res => {
          if (res.retValue[0]) {
            this.showAudio = true
            this.audio = this.seatType == 1 ? JSON.parse(res.retValue[0]) : res.retValue[0]
            this.splitPoint = splitPoint || null
            setTimeout(() => {
              this.$refs.audio.startPlayOrPause()
            }, 1000)
            this.$forceUpdate()
          } else {
            this.showAudio = false
            this.$message.error('暂无录音')
          }
        })
    },
    changeContactStatus(item) {
      // 重置联系情况
      item.contactInformation = null;
      if (item.contactStatus == 2) { // 稍后拨打
        if (item.contactInformation === 13 || item.contactInformation === 15 || item.contactInformation === 16 || item.contactInformation == null) {
          item.contactInformation = 12
        }
      } else if (item.contactStatus == 4) { // 电话随访未成功
        if (item.contactInformation == 12) {
          item.contactInformation = 13
        }
      } else if (item.contactStatus == 3) { // 电话随访成功
        if (item.contactInformation === 15 || item.contactInformation === 16 || item.contactInformation == null) {
          item.contactInformation = 12
        }
      }

      this.currentRelationPatientInfo = JSON.parse(JSON.stringify(item))
      console.log('this.currentRelationPatientInfo', this.currentRelationPatientInfo);
      this.updateUserPhone(2)
    },
    changeContactInformation(item) {
      this.currentRelationPatientInfo = JSON.parse(JSON.stringify(item))
      this.updateUserPhone(2)
    },

    relationCallStatechangeHandler(item, type) {
      this.currentRelationPatientInfo = item
      this.updateUserPhone(type)
    },
    refreshAudioList(item) {
      this.getFollowupPatientRecordList(item)
    },
    callHistoryClickHandler(item) {

      return new Promise(resolve => {
        if (!item.showAudio) {
          this.currentRelationPatientInfo = item
          this.getFollowupPatientRecordList(item)
            .then(() => {
              if (item.phoneRecordInfoList && item.phoneRecordInfoList.length) {
                this.$delete(item, 'showAudio')
                this.$set(item, 'showAudio', true)
                // item.showAudio = !item.showAudio
              } else {
                this.$message.error('暂无记录')
              }

              resolve()
            })
        } else {
          console.log(111);
          this.$delete(item, 'showAudio')
          this.$set(item, 'showAudio', false)
          resolve()
        }
      })


    },
    async getRecordList(concatId) {
      let request = new RestNewFollowupCallCenterServiceGetALiRecording()
      request.p_contactId = concatId
      await request.send()
      return request.result
    },
    //===========================calling==============
    secondText() {
      let value = this.seconding;
      var theTime = parseInt(value); // 秒
      var middle = 0; // 分
      var hour = 0; // 小时

      if (theTime >= 60) {
        middle = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (middle >= 60) {
          hour = parseInt(middle / 60);
          middle = parseInt(middle % 60);
        }
      }
      var result =
        parseInt(theTime) < 10
          ? "0" + parseInt(theTime)
          : "" + parseInt(theTime);
      var middleText =
        parseInt(middle) < 10 ? "0" + parseInt(middle) : "" + parseInt(middle);
      result = middleText + ":" + result;
      if (hour > 0) {
        result = parseInt(hour) + ":" + result;
      }
      return result;
    },
    // 获取当前的拨叫状态
    getCurrentCode() {
      console.log('getStatus', window.workbench && window.workbench.getStatusCode() && window.workbench.getStatusCode().code);
      return window.workbench && window.workbench.getStatusCode() && window.workbench.getStatusCode().code || null
    },
    calling() {
      if (window.workbench) {
        console.log('status', this.status);
        if (this.status === "work") {
          // call(callee, caller, publicKey, useVirNumCall)
          // callee为被叫号码不可空，必传，加密时传加密后的密文，不加密时传真实被叫号码。
          // caller为主叫号码，可以指定主叫号码，不使用加密时可以不传，或者传‘auto’。不传时使用面板里选择的主叫号码或技能组所绑定外呼号码的第一个,为‘auto’时，根据外呼的号码的归属地选择与与其同一归属地的主叫号码，若没有同一归属地的就随机在技能组里选择一个主叫号码。使用加密时必传。
          // publicKey为公钥，对被叫号码进行加initAliyunCall密时该值必传，非加密情况不传或传空值。使用加密方式外呼时,需要调用加密接口 [Encrypt ](https://help.aliyun.com/document_detail/75726.html) 将号码进行加密，得到加密后的被叫号码和公钥后直接调用该call方法：call('密文', '主叫号码', '公钥' )。
          // useVirNumCall为Boolean类型，传true表示只要caller配置了虚拟号码都会使用虚拟号码进行外呼，不传或传false,如果您使用呼叫中心的面板进行操作，会根据坐席是否选择使用外呼号码进行呼叫，如果勾选了则将使用虚拟号码进行外呼否则直接用呼叫中心的号码进行呼叫。
          console.log('calling  -------------- ', this.nextCallNumber)
          this.beforeCall()
            .then((res) => {
              if (res) {
                if (this.nextCallNumber) {
                  window.workbench.call(this.nextCallNumber, this.calleePhoneNumber, null, false); // TODO
                  this.setCurrentCallNumber({
                    currentCallNumber: this.nextCallNumber,
                    currentCallNumberId: this.nextCallNumberId
                  })
                  this.setCurrentCalling(true)
                  this.setCallingStatus();
                  window.pubsub && window.pubsub.emit('calling');
                } else {
                  this.errorHandle({
                    message: '该患者无可拨打的电话'
                  })
                }
              } else {
                this.$message.error('缺少contractId')
              }
            })

          // // for 测试
          // window.workbench.call("15708497684", "auto", null, false); // TODO
          // this.setCurrentCallNumber({currentCallNumber:this.nextCallNumber ,currentCallNumberId : this.nextCallNumberId})
          // this.setCallingStatus();
          // window.pubsub&&window.pubsub.emit('calling');
        } else {
          this.errorHandle({
            message: "请先重新回到工作中。。。"
          });
        }
      } else {
        this.errorHandle({
          message: "云呼叫中心无法连接，请退出重新登录"
        });
      }
    },
    listenHangUp() {
      console.log('listenHangUp');
      this.setCallHangUpStatusDialog()
      // this.setCurrentCalling(false)
      this.setHangUpStatus();
      // window.pubsub && window.pubsub.emit('callHangUp');
      // clearInterval(this.timer)
      clearInterval(this.intervalTimer)
      this.setCallTime()
      this.hangState = false //已挂断0
    },
    hangUpHuaweiCall(boolean) {
      console.log("hangUpHuaweiCall", boolean)
      this.setCallHangUpStatusDialog()
      this.callSuccess = boolean
      this.hangState = false //已挂断0

    },
    //点击挂断的操作
    hangUp() {
      console.log('hangUp');
      if (window.workbench) {
        console.log(window.workbench.getStatusCode().code);
        // this.$message.info('提示请忽略：当前状态 ' + window.workbench.getStatusCode().code)
        if (window.workbench.getStatusCode().code == -1) {
          this.$message.error('当前状态不能挂断电话')
        }
        // 挂断
        window.workbench.hangUp();
        // this.setCallHangUpStatusDialog()
        // this.setCurrentCalling(false)
        // this.setHangUpStatus();
        window.pubsub && window.pubsub.emit('callHangUp');
        // 如果是 这个页面
        // clearInterval(this.timer)
      } else {
        this.errorHandle({
          message: "云呼叫中心无法连接，请退出重新登录"
        });
      }
      // this.setCallTime()
    },
    // 电话保持
    callHold() {
      if (window.workbench) {
        if (this.getCurrentCode() == 10 || this.getCurrentCode() == 9) {
          window.workbench.callHold();
          this.isCallHold = false;
        } else {
          this.$message({
            type: "warning",
            message: "您好，此时您的状态不能进行通话保持"
          });
        }

      } else {
        this.errorHandle({
          message: "云呼叫中心无法连接，请退出重新登录"
        });
      }
    },
    // 电话取回
    callRetrieve() {
      // 12
      if (window.workbench) {
        // 挂断
        window.workbench.callRetrieve();
        this.isCallHold = true;
      } else {
        this.errorHandle({
          message: "云呼叫中心无法连接，请退出重新登录"
        });
      }
    },
    // 挂断后的状态
    setHangUpStatus() {
      this.intervalTimer && clearInterval(this.intervalTimer);
      // this.seconding = 0;
      this.isCalling = false;
    },
    // 拨打的状态
    setCallingStatus() {
      this.isCalling = true;
      this.intervalTimer = setInterval(() => {
        this.seconding++;
      }, 1000);
    },
    // ================== validator ===================
    phoneValidator(rule, value, callback) {
      if (/^1[34578]\d{9}$/.test(value)) {
        callback()
      } else {
        callback('手机号码不符合规范')
      }
    },
    nextTimeValidator(rule, value, callback) {
      console.log(rule, value, callback)
      if (value) {
        let selectTime = new Date(value).getTime()
        let now = new Date().getTime();
        if (selectTime < now) {
          callback('选择的时间必须为未来时间')
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    async getPhoneNumberOperator(number) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetPhoneNumberOperator',
        params: {
          phoneNumber: number
        }
      })
      return result
    },
    sonSmsSelectHandler(item) {
      if(this.selectSonSms.id == item.id) {
        this.selectSonSms = {
          id: null,
          smsContent: null
        }
      }else {
        this.selectSonSms = item
      }
    },
    //获取短信列表
    getSmsList() {
      this.asyncGetSmsList()
        .then(res => {
          console.log(res);
          if (res.status == 0) {
            this.smsList = res.retValue
          } else {
            this.$message.error(res.desc)
          }
        })
    },
    checkHasLastCallUser() {
      return new Promise(resolve => {
        let lastCallUser = this.patientList.find(item => item.isLast)
        if (!lastCallUser) {
          resolve(false)
        } else {
          resolve(lastCallUser.lastCallState)
        }
      })
    },
    //操作前的判断 最近拨叫是初始化就需要报错
    checkSubmitStatus(callnum) {
      console.log(1111);
      return new Promise(resolve => {
        let lastCallUser = this.patientList.find(item => item.isLast)
        console.log(lastCallUser);
        if (!lastCallUser) {
          this.statusError = false
          resolve(true)
        } else {
          // if(callnum && callnum == lastCallUser.phoneNumber) {
          //     resolve(true)
          //     this.statusError = false
          // }

          // if (lastCallUser.lastCallState == 5) {
          //   this.statusError = true
          //   this.$message.error('请选择呼叫状态')
          //   resolve(false)
          // } else {
          //   this.statusError = false
          //   resolve(true)
          // }
          this.statusError = false
          resolve(true)
        }
      })
    },
    //=========================电话接通============================

    isStatusDisabled(statusValue) {
      if (!this.selectedSituation) return false;

      // 当选择了联系情况时的限制
      switch (this.selectedSituation) {
        case 12: // 沟通顺畅
          return statusValue === 4; // 不可选电话随访未成功
        case 15: // 错号
        case 16: // 不知情
          return statusValue === 3 || statusValue === 2; // 不可选电话随访成功
        case 13: // 拒绝随访
          return statusValue === 2; // 不可选稍后拨打
        case 18: // 无
          return statusValue === 3 || statusValue === 2; // 不可选电话随访成功
        default:
          return false;
      }
    },

    isSituationDisabled(situationValue) {
      if (!this.selectedStatus) return false;

      // 当选择了联系状态时的限制
      switch (this.selectedStatus) {
        case 3: // 电话随访成功
          return situationValue === 15 || situationValue === 16 || situationValue === 18; // 不可选错号、不知情
        case 2: // 稍后拨打
          return situationValue === 13 || situationValue === 15 || situationValue === 16 || situationValue === 18; // 不可选错号、不知情、拒绝随访
        case 4: // 电话随访未成功
          return situationValue === 12; // 不可选沟通顺畅
        default:
          return false;
      }
    },

    isSituationDisabledRow(optionValue, contactStatus) {
      switch (contactStatus) {
        case 3: // 电话随访成功
          return optionValue === 15 || optionValue === 16 || optionValue === 18; // 不可选错号、不知情
        case 2: // 稍后拨打
          return optionValue === 13 || optionValue === 15 || optionValue === 16 || optionValue === 18; // 不可选错号、不知情、拒绝随访
        case 4: // 电话随访未成功
          return optionValue === 12; // 不可选沟通顺畅
        default:
          return false;
      }
    },
    selectStatus(value) {
      // 如果当前选择的联系情况与新的状态不兼容，清除联系情况的选择
      if (this.selectedSituation && this.isSituationDisabled(this.selectedSituation)) {
        this.selectedSituation = null;
      }
      this.selectedStatus = value;
      this.checkAndLogSelection();
    },

    selectSituation(value) {
      // 如果当前选择的联系状态与新的情况不兼容，清除联系状态的选择
      if (this.selectedStatus && this.isStatusDisabled(this.selectedStatus)) {
        this.selectedStatus = null;
      }
      this.selectedSituation = value;
      this.checkAndLogSelection();
    },
    checkAndLogSelection() {
      console.log('选择结果：', {
        status: this.selectedStatus,
        situation: this.selectedSituation
      });
      // 稍后拨打需要选时间--确认
      if (this.selectedStatus && this.selectedSituation && this.selectedStatus != 2) {

        //非稍后拨打情况
        // afterCallHandle(contactStatus, contactInformation,status, finshStatus)
        this.afterCallHandle(this.selectedStatus, this.selectedSituation, 6)
      }

      // 保存
      // this.callStatusVisible = false;
      // if (this.selectedStatus && this.selectedSituation) {
      //   const statusItem = this.contactStatusList.find(item => item.value === this.selectedStatus);
      //   const situationItem = this.contactInformationList.find(item => item.value === this.selectedSituation);

      //   const statusLabel = statusItem ? statusItem.label : '';
      //   const situationLabel = situationItem ? situationItem.label : '';

      //   console.log('选择结果：', {
      //     status: { value: this.selectedStatus, label: statusLabel },
      //     situation: { value: this.selectedSituation, label: situationLabel }
      //   });
      // }
    },
    // ========================= 联系人的保存 =========================
    // 编辑按钮事件
    // editRelation(item) {
    //   this.phoneDialogVisible = true;
    //   this.dialogType = 'edit';
    //   this.currentRelationPatientInfo = item;
    //   this.$nextTick(() => {
    //     // this.$refs['validatorForm'].resetFields();
    //     this.form = {
    //       phoneNumber: item.phoneNumberStar,
    //       relationshipName: item.relationshipName ? item.relationshipName : "",
    //       lastCallState: item.lastCallState ? item.lastCallState : ""
    //     }
    //   })
    // },
    // 新增按钮事件
    addHandle() {
      // 如果是发送 短信页面 ,切换状态
      if (this.isModel === 'messageing') {
        this.toggleUserMode()
      }
      this.phoneDialogVisible = true;
      this.dialogType = 'add';
      this.$nextTick(() => {
        // this.$refs['validatorForm'].resetFields();
        // this.form = {
        //   ...{
        //     phoneNumber: '',
        //     relationshipLevel: '',
        //     relationshipLevelId: ''
        //   }
        // }
        this.addContactInfo = [{
          phoneType: true,
          phoneNumber: null,
          contactName: null,
          relationshipLevel: null,
          relationshipLevelId: null,
          relationshipName: null,
          cooperateScore: null,
          code: null,
          isChecked: false,
        }]
      })
    },
    // 取消 dialog
    addContactHandle() {
      let _data = {
        phoneType: true,
        phoneNumber: null,
        contactName: null,
        relationshipLevel: null,
        relationshipLevelId: null,
        relationshipName: null,
        cooperateScore: null,
      }
      this.addContactInfo.push(_data)
    },
    deleteContactHandle(index) {
      this.addContactInfo.splice(index, 1)
    },
    changeInput() {
      this.$forceUpdate() //强制刷新
    },
    //  保存 dialog---hmz
    phoneTypeChange(contact) {
      contact.code = null
      contact.phoneNumber = null
    },
    // 校验号码
    checkPhoneNumber(contact) {
      contact.isChecked = false
      if (!contact.phoneType && !(contact.code && contact.phoneNumber)) { //座机
        // console.log("校验座机，不调用")
        return
      }
      if (contact.phoneNumber) {
        let _phoneNumber = contact.code ? `${contact.code}-${contact.phoneNumber}` : contact.phoneNumber
        this.$store.dispatch('requestHandler', {
          fn: 'RestNewFollowupCallCenterServiceCheckPhoneNumber',
          params: {
            phoneNumber: _phoneNumber,
          }
        }).then(res => {
          if (res.status == 0) {
            contact.isChecked = true
          } else {
            this.$message.error(res.desc); // 校验失败
            return
          }
        })
      }
    },
    saveHandle() {
      let filter_list = this.addContactInfo.filter(item => {
        if (item.phoneType == null) {
          return item
        } else if (item.phoneType && !item.phoneNumber) {
          return item
        } else if (item.phoneType === false && (!item.code || !item.phoneNumber)) {
          return item
        }
      })
      if (filter_list.length > 0) {
        this.$message.warning("请检查联系方式和号码是否填写完整")
        return
      }

      //校验号码是否有重复输入的
      let duplicatePhoneNumbers = this.addContactInfo.filter((item, index) => {
        // 使用 findIndex 方法查找当前元素之前是否已经存在相同的 phoneNumber
        let _pbone = item.code ? `${item.code}-${item.phoneNumber}` : item.phoneNumber
        const firstIndex = this.addContactInfo.findIndex((el, i) => {
          let el_pbone = el.code ? `${el.code}-${el.phoneNumber}` : el.phoneNumber
          return el_pbone === _pbone && i < index
        });
        return firstIndex !== -1; // 如果找到相同的 phoneNumber，则保留该元素
      });
      if (duplicatePhoneNumbers.length > 0) {
        let msg = duplicatePhoneNumbers.map(item => item.phoneNumber)
        this.$message.error(`号码${msg.join('、')}已存在`)
        return
      }
      let hasNotChecked = this.addContactInfo.filter(contact => !contact.isChecked)
      if (hasNotChecked.length > 0) {
        let msg = hasNotChecked.map(item => {
          let _phone = item.code ? `${item.code}-${item.phoneNumber}` : item.phoneNumber
          return _phone
        })
        this.$message.error(`号码${msg.join('、')}填写有误`)
        return
      }

      let _list = this.addContactInfo.map(item => {
        let temp = {
          phoneNumber: item.code ? `${item.code}-${item.phoneNumber}` : item.phoneNumber,
          relationshipName: item.relationshipName,
          contactName: item.contactName,
          phoneType: item.phoneType,
          relationshipLevel: item.relationshipLevel,
          cooperateScore: item.cooperateScore,
        }
        return temp
      })
      // console.log('保存', _list);
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestNewFollowupCallCenterServiceBatchAddFollowupPatientContactInformation',
          params: {
            nowUserId: this.userid,
            patientId: this.patientId,
            followupTaskId: this.getTaskCenterId,
            contactInformationList: _list,
          }
        }
      ).then(res => {
        if (res.retValue == 'SUCCESS') {
          this.$message.success('新增成功')
          this.$emit('refreshConcatInfo', this.patientId)
          this.phoneDialogVisible = false
        } else {
          this.errorHandle(res)
        }
      })
    },
    // 添加联系人
    addUserPhone() {
      let vm = this;
      let params = {
        // taskId: this.taskId,
        // patientId: this.patientId,
      };
      var second = vm.patientList.filter((item) => {
        if (item.relationshipName.indexOf(params.relationshipName) != -1) {
          return item
        }
      })
      if (second.length > 0) {
        params.relationshipName = params.relationshipName + (second.length + 1)
      }
      if (typeof params.patientId === "undefined") {
        this.errorHandle({ message: "无法获取患者的ID" });
        return false;
      }
      return this.asyncAddUserPhone(params).then((data) => {
        if (data.status === 0) {
          // 获取用户 列表  TODO
          this.successHandle({ message: "添加患者手机成功" })
          this.patientList.unshift({
            id: data.retValue,
            lastCallState: 5,
            contactStatus: 1,//初始化
            contactInformation: 11,//初始化
            phoneNumber: params.phoneNumber,
            contactName: params.contactName,
            relationshipName: params.relationshipName,
            lastCallTime: "",
            phoneNumberStar: params.phoneNumber.substring(0, 3) + '****' + params.phoneNumber.substring(7),
            isTodayCall: false,
          })
          // this.getNextCallNumber()
          vm.$emit('refreshConcatInfo', this.patientId)
          this.phoneDialogVisible = false;
        } else {
          this.errorHandle(data)
        }
      }).catch((err) => {
        console.log('user phoneNumber add handle --- ', err)
        this.errorHandle(err);
      })
    },
    // 取消联系人
    cancelMessageHandle() {
      let res = []
      _.each(this.patientList, (item) => {
        if (_.indexOf(this.checkPhoneList, item.id) > -1) {
          if (item.isBeenSend) {
            res.push(item.id)
          }
        }
      })
      this.checkPhoneList = [].concat(res)
      this.isModel = 'beMessage'
    },
    // 修改联系人
    updateUserPhone(updateType) {
      let vm = this;
      let data = this.currentRelationPatientInfo || {};
      let params = {
        updateType: updateType,
        id: data.id || null,
        patientId: this.patientId,
        phoneNumber: this.currentRelationPatientInfo.phoneNumber,
        relationshipName: this.currentRelationPatientInfo.relationshipName,
        contactName: this.currentRelationPatientInfo.contactName,
        lastCallState: data.lastCallState || null,

        contactStatus: this.currentRelationPatientInfo.contactStatus,
        contactInformation: this.currentRelationPatientInfo.contactInformation,
      };
      var srcRel = vm.relationShipList.find((v, i) => {
        return params.relationshipName.indexOf(v.relationshipName) != -1
      })
      if (srcRel) {
        var second = vm.patientList.filter((item) => {
          if (item.relationshipName.indexOf(srcRel.relationshipName) != -1 && item.id != data.id) {
            return item
          }
        })
        if (second.length > 0) {
          params.relationshipName = srcRel.relationshipName + (second.length + 1)
        }
      }
      if (typeof params.patientId === "undefined") {
        this.errorHandle({ message: "无法获取患者的ID" });
        return false;
      }

      this.asyncGetFollowupPatientContactInformation(params).then(res => {
        if (res.retValue.length > 0) {
          params.callDate = res.retValue[0].copyLastCallTime
          this.asyncUpdateUserPhone(params).then((data) => {
            if (data.status === 0) {
              // 更新用户 列表 TODO
              this.patientList.forEach((v, i) => {
                if (v.id == params.id) {
                  v.relationshipName = params.relationshipName;
                  v.lastCallState = params.lastCallState
                }
              })
              this.successHandle({ message: "编辑成功" })
              vm.$emit('refreshConcatInfo', this.patientId)
              this.phoneDialogVisible = false;
            } else {
              this.errorHandle(data)
            }
          })
        }
      })
    },
    //  ============================================== 发送短信 ==================================================
    getSonSmsTemplateList(id) {
      this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetSonSmsTemplateList',
        params: {
          fatherId: id
        }
      }).then(res => {
        if (res.status == 0) {
          this.smsSonList = res.retValue
        }else {
          this.$message.error(res.retValue)
        }
      })
    }, 
    // 处理选中状态的值
    handleChangeUser() {
      console.log('handleChangeUser', arguments, this.checkPhoneList)
    },
    toggleUserMode() {
      if (this.isModel === 'beMessage') {
        this.isModel = 'messageing'
      } else {
        this.isModel = 'beMessage'
      }
    },
    sendMessageHandle(item) {
      item.isTodayCall = null
      item.lastCallTime = ""
      if (!this.smsSelect) {
        this.$message.error('请选择短信模板')
        return
      }
      this.getPhoneNumberOperator(item.phoneNumber)
      .then(res => {
        let dict = {
          '中国联通': 1,
          '中国电信': 2,
          '中国移动': 3,
          '其他': 4
        }
        this.selectSonSms = this.smsSonList.find(v => {
          return dict[res.retValue] == v.operatorType
        }) || {
          id: null,
          smsContent: null
        }
        console.log('getPhoneNumberOperator', res,dict[res.retValue] )
      })
      let itemAfter = JSON.parse(JSON.stringify(item))
      itemAfter.contactStatus = item.contactStatus == '初始化' ? 1 : item.contactStatus
      itemAfter.contactInformation = item.contactInformation == '初始化' ? 11 : item.contactInformation
      this.sendMessageLoading = false
      this.getSmsSendRecord()
      this.messageDialogVisible = true
      this.messageTarget = itemAfter
    },
    getSmsSendRecord() {
      this.smsSendRecordLists = []
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestNewFollowupCallCenterServiceGetSmsSendRecord',
          params: {
            followupTaskId: this.getTaskCenterId,
            followUpPatientId: this.patientData.followupPatientId
          }
        }
      ).then(res => {
        if (res.status == 0) {
          this.smsSendRecordLists = res.retValue
        }
      })
    },
    // 发送短信
    sendMessage() {
      this.sendMessageLoading = true
      console.log(this.messageTarget);

      return this.asyncSendMessage({
        phoneNumbers: [this.messageTarget]
      }).then(data => {
        if (data.status === 0) {
          // TODO
          this.$message.success('发送短信成功')
          this.messageTarget = {
            phoneNumberStar: ''
          }
          this.messageDialogVisible = false
        } else {
          this.errorHandle(data)
          this.sendMessageLoading = false
        }
      }).catch(err => {
        console.log('send message handle --- ', err)
        this.sendMessageLoading = false
        this.errorHandle(err);
      })
    },
    // 编辑联系人
    editContactClickHandler(item) {
      this.patientListItem = JSON.parse(JSON.stringify(item))
      // console.log('item--->', item);
      let phoneNumber_code = this.patientListItem.phoneNumber.split('-')
      if (phoneNumber_code.length > 1) {
        this.patientListItem.code = phoneNumber_code[0]
        this.patientListItem.phoneNumber = phoneNumber_code[1]
      }
      this.editDialogVisible = true
      if (item.relationshipName) {
        this.relationshipLevelList = [
          { value: 1, label: '一级联系人' },
          { value: 2, label: '二级联系人' },
          { value: 3, label: '三级联系人' },
        ]
      } else {
        this.relationshipLevelList = []
      }
    },
    // ========================== 获取 患者 列表 ===========================================
    getPatientList(patientList = []) {
      this.patientList = this.patientList || [];
      this.patientList.splice(0, this.patientList.length);
      if (_.isArray(patientList)) {
        _.each(patientList, (item) => {
          // 患者 数据 转换成 星号
          item.phoneNumberStar = item.phoneNumber.substring(0, 3) + '****' + item.phoneNumber.substring(7);
          if (_.indexOf(this.checkPhoneList, item.id) > -1) {
            if (!item.isBeenSend) {
              item.isBeenSend = true
            }
          }
          item.lastCallTime = item.lastCallTime.replace(/-/g, '/')
          if (new Date(item.lastCallTime).getTime() > new Date().getTime() - (3600 * 1000 * 24)) {
            item.isTodayCall = true
          }
          item.relationshipLevel = item.relationshipLevel ? item.relationshipLevel : null
          item.relationshipLevelId = item.relationshipLevelId ? item.relationshipLevelId : null
          item.showAudio = false
          item.showLoading = false
          item.contactStatus = item.contactStatus == 0 ? null : (item.contactStatus == 1 ? '初始化' : item.contactStatus)
          item.contactInformation = item.contactInformation == 18 || item.contactInformation == 0 ? null : (item.contactInformation == 11 ? '初始化' : item.contactInformation)
          this.patientList.push(item)
          let temp = this.patientList.filter(item => item.phoneLabel == '仅随访该号码')
          temp.length > 0 ? this.showGray = true : this.showGray = false
        });
      }
      this.getNextCallNumber();
    },
    // ============================================ 状态 =======================================
    //
    getCodeName(code) {
      var arr = ['稍后拨打', '仅随访该号码', '短信随访成功', '电话随访成功', '初始化', '挂断（接通）', '无人接听', '挂断（未接通）', '停机', '关机', '拒随', '空号', '错号', '不知情', '沟通不畅']
      return arr[code - 1];
    },
    getContactStatusName(contactStatus) {
      switch (contactStatus) {
        case 1:
          return '初始化';
        case 2:
          return '稍后拨打';
        case 3:
          return '电话随访成功';
        case 4:
          return '未成功';
        case '初始化':
          return '初始化';
        default:
          return '无';
      }
    },
    // 联系情况转换方法
    getContactInformationName(contactInformation) {
      switch (contactInformation) {
        case 11:
          return '初始化';
        case 12:
          return '沟通顺畅';
        case 13:
          return '拒绝随访';
        case 14:
          return '沟通不畅';
        case 15:
          return '错号';
        case 16:
          return '不知情';
        case 19:
          return "空号";
        case 20:
          return "停机";
        case 21:
          return "关机";
        case '初始化':
          return '初始化';
        default:
          return '无';
      }
    },
    //{ label: '空号', value: 19 },
    //  { label: '停机', value: 20 },
    //  { label: '关机', value: 21 },
    // 拨打电话 挂断时 刷新页面  ------ 刷新页面
    setCallHangUpStatusDialog() {
      if (!this.callSuccess) {
        this.$store.dispatch('requestHandler', {
          fn: 'RestNewFollowupCallCenterServiceGetCallRecordReleaseInitiator',
          params: {
            contactId: this.contactId.jobId
          }
        }).then(res => {
          if (res.status == 0 && res.retValue) {
            //agent 坐席挂断 ：标记【无人接听】，联系状态标记【电话随访未成功】，联系情况标记为【无】
            //customer 用户挂断 ：标记【挂断（未接通）】，联系状态标记【电话随访未成功】，联系情况标记为【无】
            if (res.retValue == 'agent') {
              this.afterCallHandle(4, 18, 7)

            } else if (res.retValue == 'customer') {
              this.afterCallHandle(4, 18, 8)
            }
          }
        })
      } else {
        this.callStatusVisible = true;
        this.selectedStatus = null
        this.selectedSituation = null
        localStorage.setItem('callStatus', false) // 稍后拨打提醒弹框的【查看】能否点击
        this.isShowNextTimeClose = false;
        // this.currentRelationPatientInfo = {
        //   id: this.currentCallNumberId,
        //   phoneNumber: this.currentCallNumber,
        //   contactName: this.currentRelationPatientInfo.contactName
        // }
        console.log(this.currentRelationPatientInfo);
      }

    },
    //  验证时间
    beforeCallHandle(status) {
      let vm = this;
      this.$refs['nextTimeForm'].validate((valid) => {
        if (valid) {
          let params = {
            id: this.callReturnId || -1,
            userId: this.userid,
            patientId: this.patientId,
            followupPatientId: this.patientData.followupPatientId,
            followUpPatientInfoId: vm.patientData.followUpPatientInfoId,
            followupTaskId: this.getTaskCenterId,
            phoneNumber: this.currentRelationPatientInfo.phoneNumber,
            contactName: this.currentRelationPatientInfo.contactName,
            phoneNumberId: this.currentRelationPatientInfo.id,
            contactId: this.contactId,
            laterCallTime: this.nextTimeForm.nextCallTime,
            callingPhoneNumber: localStorage.getItem('callingPhoneNumber'),
            relationshipRemarks: this.patientList.find((v, i) => {
              return v.id == this.currentRelationPatientInfo.id
            }).relationshipName
          };
          this.asyncLaterCallHandle(params)
        } else {
          return false;
        }
      })

    },
    beforeCallHuawei() {
      return new Promise(resolve => {
        let vm = this;
        this.timer = setTimeout(() => {
          let params = {
            userId: this.userid,
            patientId: this.patientId,
            contactName: this.currentRelationPatientInfo.contactName,
            followupPatientId: this.patientData.followupPatientId,
            followUpPatientInfoId: vm.patientData.followUpPatientInfoId,
            followupTaskId: this.getTaskCenterId,
            phoneNumber: this.callingNumber.number,
            phoneNumberId: this.callingNumber.id,
            contactId: this.contactId,
            callingPhoneNumber: localStorage.getItem('callingPhoneNumber'),
          };
          if (!this.contactId) {
            this.$message.error('缺少录音id')
            resolve(false)
          } else {
            this.firstUpdatePhoneNumberCallState(this.contactId, params)
              .then(res => {
                this.callReturnId = res.retValue
                if (res.status == 0) {
                  resolve(true)
                  localStorage.setItem('callStatus', true) // 稍后拨打提醒弹框的【查看】能否点击,true表示正在通话
                } else {
                  this.$message('接口报错联系后端')
                  return false
                }
              })
          }
        }, 0)
      })
    },

    beforeCall() {
      this.hangState = true
      return new Promise(resolve => {
        let vm = this;
        this.hangupDisabled = true
        this.timer = setTimeout(() => {
          let params = {
            userId: this.userid,
            patientId: this.patientId,
            contactName: this.currentRelationPatientInfo.contactName,
            followupPatientId: this.patientData.followupPatientId,
            followUpPatientInfoId: vm.patientData.followUpPatientInfoId,
            followupTaskId: this.getTaskCenterId,
            phoneNumber: this.callingNumber.number,
            phoneNumberId: this.callingNumber.id,
            contactId: this.contactId,
            callingPhoneNumber: localStorage.getItem('callingPhoneNumber'),
          };
          if (!this.contactId) {
            this.$message.error('缺少录音id')
            resolve(false)
          } else {
            this.firstUpdatePhoneNumberCallState(this.contactId, params)
              .then(res => {
                this.callReturnId = res.retValue
                if (!this.hangState) { //这个状态不对直接不能打电话
                  return false
                }
                if (res.status == 0) {
                  this.hangupDisabled = false
                  resolve(true)
                  localStorage.setItem('callStatus', true) // 稍后拨打提醒弹框的【查看】能否点击,true表示正在通话
                } else {
                  this.$message('接口报错联系后端')
                  this.hangupDisabled = false
                  return false
                }
              })
          }
        }, 0)
      })
    },
    //挂断电话
    afterCallHandle(contactStatus, contactInformation, status, finshStatus) {
      let vm = this;
      if (!this.currentRelationPatientInfo || !this.currentRelationPatientInfo.id) {
        this.$message.error('缺少currentRelationPatientInfo', this.currentRelationPatientInfo)
      }

      let params = {
        id: this.callReturnId || -1,
        userId: this.userid,
        patientId: this.patientId,
        callPlatform: this.seatType,
        followupPatientId: this.patientData.followupPatientId,
        followUpPatientInfoId: vm.patientData.followUpPatientInfoId,
        followupTaskId: this.getTaskCenterId,
        contactName: this.currentRelationPatientInfo.contactName,
        followupSource: this.$route.query.followupSource || 1,
        // phoneNumber: this.currentRelationPatientInfo.phoneNumber,
        // phoneNumberId: this.currentRelationPatientInfo.id,
        phoneNumber: this.callingNumber.number,
        phoneNumberId: this.callingNumber.id,
        callState: status,
        contactStatus: contactStatus, // 联系状态
        contactInformation: contactInformation || null, // 联系情况
        contactId: this.concatIDBackUp || this.contactId || JSON.parse(localStorage.getItem('contactId')) || JSON.parse(window.sessionStorage.getItem('contactId')),
        callingPhoneNumber: localStorage.getItem('callingPhoneNumber'),
        callTime: this.seconding || 0,
        laterCallTime: this.nextTimeForm.nextCallTime,
        relationshipRemarks: this.patientList.find((v, i) => {
          return v.id == this.currentRelationPatientInfo.id
        }).relationshipName



      };
      console.log('laterCallTime--', params)
      if (!this.concatIDBackUp && !this.contactId && !JSON.parse(localStorage.getItem('contactId'))) {
        vm.$message.error("我已经默默为您服务很久了，请让我休息一下，提交之后，请退出登录")
      }
      this.asyncSetTaskStatus(params).then((data) => {
        this.nextTimeForm.nextCallTime = '';
        if (data.status === 0) {

          this.cancelNextTime();
          this.getNextCallNumber()
          // 判断状态
          var lostNumber = 0
          this.patientList.forEach((item) => {
            if (item.id == params.phoneNumberId) {
              item.lastCallState = status
              item.isTodayCall = true
            }
            if (this.isAbnormal && item.isTodayCall && (item.lastCallState == 13 || item.lastCallState == 12)) {
              lostNumber = lostNumber + 1
            }
            if (!this.isAbnormal && item.isTodayCall && item.lastCallState != 2 && item.lastCallState != 4 && item.lastCallState != 11) {
              lostNumber = lostNumber + 1
            }
          })
          if (lostNumber == this.patientList.length) {
            finshStatus = 'lostStatus'
          }
          console.log('finshStatus===============', finshStatus);
          this.$emit('getOverFollowUp', finshStatus)
          this.$emit('refreshConcatInfo', this.patientId)

          this.callReturnId = null
          this.seconding = 0
          //
          this.callStatusVisible = false
          this.callSuccess = false;
          console.log('RE');
          this.refreshCallList()
          this.huaweiCalling = false
        } else {
          this.huaweiCalling = false
          this.errorHandle(data)
        }
        console.log("SUCCESS");
      }).catch((err) => {
        this.nextTimeForm.nextCallTime = '';
        console.log('Patient handle --- ', err)
        this.errorHandle(err)
      })
    },
    // 稍后拨打 --- 打开 timeDate
    callLaterHandler(status = 1) {
      this.callNextTimeVisible = true;
    },
    cancelNextTime() {
      // 取消打开的日期
      this.callNextTimeVisible = false;
    },
    async setCallTime() {
      var vm = this;
      var info = new RestNewFollowupCallCenterServiceAddRecordWaitingTime();
      info.p_id = vm.callReturnId
      info.p_contactId = vm.contactId.jobId || -1;
      var contactTime = localStorage.getItem("contactTime")
      var endTime = new Date().valueOf()
      var startTime = localStorage.getItem("startTime")
      if (contactTime) {
        info.p_waitingTime = contactTime - startTime
        info.p_talkTime = endTime - contactTime
      } else {
        info.p_waitingTime = endTime - startTime
      }
      await info.send()
      if (info.result.status == 0) {
        localStorage.removeItem("startTime")
        localStorage.removeItem("contactTime")
      }
    },
    // 操作时间 --- 过段时间再拨打
    timeTip(date) {
    },
    // ======================================= list ==================================
    // 加载新的患者数据
    loadPatientData() {
      this.$emit('saveRemark');
    },
    // 判断状态
    judgeStatus(status, isLossFollowup = false) {
      console.log(' judge status ', status, isLossFollowup, this.nextCallNumber)
      if (this.$route.query.abnormal == 2) {
        // 如果是 稍后拨打 直接跳到下一个 患者
        if (status === 1) {
          this.$notify({
            title: '提示',
            message: '本患者进入任务池，获取下一个患者信息',
            duration: 3000
          });
          this.loadPatientData();
        } else if (isLossFollowup) { // 失访
          this.$notify({
            title: '提示',
            message: '本患者已经标记为失访状态，获取下一个患者信息',
            duration: 3000
          });
          this.loadPatientData();
        } else {
          let nextCallNumber = this.nextCallNumber;
          if (nextCallNumber) {
            // 这个账号 还可以打电话
          } else {
            // 不能打电话了
            this.$notify({
              title: '提示',
              message: '该患者本次没有可以拨打的号码，患者即将进入任务池，获取下一个患者信息',
              duration: 3000
            });
            this.loadPatientData();
          }
        }
      } else {
        if (this.$route.query.abnormal == 3) {
          console.log("异常患者，需要进入下一患者了");
          this.updateNextAbnormalPatient();
        } else if (this.$route.query.abnormal == 4) {
          console.log("稍后患者，需要进入下一患者了");
          this.updateNextCallLaterPatient();
        }
      }
    },
    updateNextAbnormalPatient() {
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        currentPage: 1,
        pageSize: 10
      };
      this.getAbnormalFollowupListAsync(params).then(res => {
        console.log("跳转到当前页", res.retValue);
        if (res.retValue.length > 0) {
          this.updatePage(4, res.retValue[0])
        } else {
          console.log("无患者");
          this.$router.push({
            path: "/taskDetail",
            query: {
              diseaseId: this.$route.query.diseaseId,
            }
          });
        }
      });
    },
    updateNextCallLaterPatient() {
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        currentPage: 1,
        pageSize: 10
      };
      this.getCallLaterFollowupListAsync(params).then(res => {
        console.log("跳转到当前页", res.retValue);
        if (res.retValue.length > 0) {
          this.updatePage(4, res.retValue[0])
        } else {
          console.log("无患者");
          this.$router.push({
            path: "/taskDetail",
            query: {
              diseaseId: this.$route.query.diseaseId,
            }
          });
        }
      });
    },
    updatePage(num, params) {
      //num: 3异常患者处理  4稍后随访
      if (params.followupPatientId != this.$route.query.followupPatientId) {
        this.$router.push({
          path: "/callPatient",
          query: {
            abnormal: num,
            followUpPatientInfoId: params.followUpPatientInfoId,
            followupPatientId: params.followupPatientId,
            diseaseId: this.$route.query.diseaseId,
            patientId: params.patientId,
            followupSource: 1
          }
        });
      }
    },
    // 异常随访
    async getAbnormalFollowupListAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfoList();
      request.p_userId = p.userId;
      request.p_followupTaskId = p.followupTaskId;
      request.p_pageIndex = p.currentPage;
      request.p_pageSize = p.pageSize;
      await request.send();
      return request.result;
    },
    //获取对应关系
    async getAllRelationshipLevel() {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetAllRelationshipLevel'
      })
      return result
    },
    // 稍后随访
    async getCallLaterFollowupListAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfoList();
      request.p_userId = p.userId;
      request.p_followupTaskId = p.followupTaskId;
      request.p_pageIndex = p.currentPage;
      request.p_pageSize = p.pageSize;
      await request.send();
      return request.result;
    },
    //提交呼叫记录RestFeedbackOutControllerUpdateRecordList
    async updateRecordList(p) {
      let request = new RestFeedbackOutControllerUpdateRecordList()
      request.p_ids = p.ids
      await request.send()
      return request.result
    },
    async getFollowupPatientRecordList(item) {
      this.$delete(item, 'showLoading')
      this.$set(item, 'showLoading', true)
      let request = new RestNewFollowupCallCenterServiceGetPhoneRecordInfoListByPhoneNumber()
      request.p_phoneNumber = item.phoneNumber
      request.p_patientId = this.patientId
      request.p_followUpTaskId = this.getTaskCenterId
      await request.send()
      // return request.result
      if (request.result.status == 0) {
        item.phoneRecordInfoList = request.result.retValue
        this.$delete(item, 'showLoading')
        this.$set(item, 'showLoading', false)
      } else {
        this.$delete(item, 'showLoading')
        this.$set(item, 'showLoading', false)
        this.$message.error('error', res.desc)
        return false
      }
    },

    // 获取 关系列表
    getReationShip() {
      this.asyncGetReationShip().then((data) => {
        if (data.status === 0) {
          this.relationShipList = data.retValue || [];
        } else {
          this.errorHandle(data)
        }
      }).catch(err => {
        this.errorHandle(err);
      })
    },
    // 获取下一个打电话的状态
    getNextCallNumber() {
      //1稍后拨打，2仅随访该患者，3短信随访成功，4电话随访成功，5初始化，6挂断（接通），7无人接听，8挂断（未接通），9停机，10,关机 11拒随，12空号，13错号，14不知情"
      let nextCallNumber = null;
      let nextCallNumberId = null;
      if (_.isArray(this.patientList)) {
        for (let i = 0; i < this.patientList.length; i++) {
          let item = this.patientList[i];
          // 非今天打过了电话
          if (!item.isTodayCall) {
            nextCallNumber = item.phoneNumber;
            nextCallNumberId = item.id;
            break;
          }
        }
      }
      // 存储到 stroe 中
      this.setNextCallNumber({ nextCallNumber, nextCallNumberId });
      return nextCallNumber;
    },
    // ======================类别相关 ===================
    getPhoneLabelList(param, index) {
      // this.$refs[`popover-`+param.id][0].doShow();
      this.customLabel = ''
      this.selectPhoneLabelId = ''
      this.asyncGetPhoneLabelList(param.id).then(res => {
        if (res.status == 0 && res.retValue == []) {
          this.radioCheck = '无标签'
          this.selectPhoneLabelId = null
          this.phoneLabelList = []
          this.selectPhoneLabelId = ''
        } else {
          let tt = res.retValue.find(it => it.label != '无标签' && it.label != '仅随访该号码')
          tt ? this.customLabel = tt.label : this.customLabel == ''
          this.radioCheck = param.phoneLabel
          this.phoneLabelList = res.retValue
        }
      })
    },
    inputFocus(param) {
      if (this.phoneLabelList.length > 0) {
        let temp = this.phoneLabelList.find(item => item.label == this.customLabel)
        temp ? this.selectPhoneLabelId = temp.id : ''
      }
    },
    categoryCheckChange(e, param, isChoose) {
      this.radioCheck = e;
      let temp = this.phoneLabelList.filter(item => item.label == e)
      if (temp.length > 0 && (e || e == '无标签' || e == '仅随访该号码')) {
        // 无标签。仅随访
        this.selectPhoneLabelId = temp[0].id
      } else if (!this.selectPhoneLabelId) {
        this.selectPhoneLabelId = ''
      }
      let data = {
        id: this.selectPhoneLabelId,
        patientId: this.patientId,
        taskId: this.getTaskCenterId,
        phoneId: param.id,
        label: isChoose ? e : this.customLabel,
        isChoose: isChoose
      }
      this.asyncAddOrSelectPhoneLabel(data).then(res => {
        if (res.status == 0) {
          // this.$refs[`popover-`+param.id][0].doClose();
          // this.$refs[`popover-`+param.id][0].doClose()
          document.body.click()
          this.refreshCallList()
        }
      })
    },
    refreshCallList() {
      this.patientList = []
      console.log('refresh')
      this.removeContactId();
      this.concatIDBackUp = ""
      localStorage.removeItem('concatID')
      this.asyncGetFollowupPatientContactInformation({ patientId: this.patientId }).then(res => {
        this.patientList = res.retValue.map(item => {
          item.phoneNumberStar = item.phoneNumber.substring(0, 3) + '****' + item.phoneNumber.substring(7)
          item.relationshipLevel = item.relationshipLevel == 0 ? null : item.relationshipLevel
          item.contactStatus = item.contactStatus == 0 ? null : (item.contactStatus == 1 ? '初始化' : item.contactStatus)
          item.contactInformation = item.contactInformation == 18 || item.contactInformation == 0 ? null : (item.contactInformation == 11 ? '初始化' : item.contactInformation)
          // item.showLoading = false
          return item
        })

        console.log('联系人列表------------------------', this.patientList);
        //
        let temp = this.patientList.filter(item => item.phoneLabel == '仅随访该号码')
        temp.length > 0 ? this.showGray = true : this.showGray = false
      })

      this.$forceUpdate()
    },
    closePop(param) {
      document.body.click()
    },
    afterCallConfirm(formData) {
      if (!this.selectedStatus || !this.selectedSituation) {
        this.$message.warning("联系状态和联系情况必选！")
        return
      }
      // this.$refs[formData].validate(valid => {
      //   if (valid) {
      this.afterCallHandle(this.selectedStatus, this.selectedSituation, 1)
      // }
      // })
    },
    async asyncGetPhoneLabelList(phoneid) {
      let request = new RestNewFollowupCallCenterServiceGetPhoneLabelList()
      request.p_phoneId = phoneid
      await request.send()
      return request.result
    },
    async asyncAddOrSelectPhoneLabel(p) {
      let request = new RestNewFollowupCallCenterServiceAddOrSelectPhoneLabel()
      request.p_id = p.id
      request.p_patientId = p.patientId
      request.p_taskId = p.taskId
      request.p_phoneId = p.phoneId
      request.p_label = p.label
      request.p_isChoose = p.isChoose
      await request.send()
      return request.result
    },
    //  ======================  async  ==========================================
    //获取短信列表
    async asyncGetSmsList(p) {
      let request = new RestNewFollowupCallCenterServiceGetSmsTemplateTaskList()
      request.p_followUpTaskId = this.getTaskCenterId
      await request.send()
      return request.result
    },
    async asyncLaterCallHandle(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceUpdateLaterCallFollowupTask();
      for (var keys in params) {
        info['p_' + keys] = params[keys]
      }
      await info.send()
      if (info.result.status == 0) {
        vm.judgeStatus(1)
        vm.callStatusVisible = false;
        vm.cancelNextTime()
        this.seconding = 0
        this.callReturnId = null
      } else {
        vm.$message.error("稍后拨打错误：" + info.result.desc)
      }
    },
    /**
     * 添加联系人接口
     * @param params={patientId,phoneNumber,relation}
     * @return id 添加题目的id
     */
    async asyncAddUserPhone(params) {
      let data = new RestNewFollowupCallCenterServiceAddFollowupPatientContactInformation();
      data.p_patientId = this.patientId;
      data.p_nowUserId = sessionStorage.getItem('userid')
      data.p_phoneNumber = params.phoneNumber;
      data.p_relationshipName = params.relationshipName;
      data.p_contactName = params.contactName
      data.p_followupTaskId = this.getTaskCenterId
      data.p_phoneType = params.phoneType
      data.p_relationshipLevelId = params.relationshipLevelId
      data.p_cooperateScore = params.cooperateScore
      console.log(data);
      await data.send();
      return data.result
    },
    // 获取患者联系方式
    async asyncGetFollowupPatientContactInformation(params) {
      let data = new RestNewFollowupCallCenterServiceGetFollowupPatientContactInformationList();
      data.p_patientId = params.patientId
      data.p_followupTaskId = this.getTaskCenterId
      await data.send();
      return data.result;
    },
    // 修改联系人
    async asyncUpdateUserPhone(params) {
      let data = new RestNewFollowupCallCenterServiceUpdateFollowupPatientContactInformation();
      data.p_id = params.id;
      data.p_patientId = this.patientId
      data.p_contactName = params.contactName
      data.p_phoneNumber = params.phoneNumber;
      data.p_nowUserId = sessionStorage.getItem('userid')
      data.p_relationshipName = params.relationshipName;
      data.p_lastCallState = params.lastCallState;
      data.p_updateType = params.updateType
      data.p_taskId = this.getTaskCenterId
      data.p_callDate = params.callDate
      data.p_contactStatus = params.contactStatus
      data.p_contactInformation = params.contactInformation || 18   // 18：联系情况为 无

      await data.send();
      return data.result;
    },
    // 失效随访  或者 暂时添加状态
    async asyncSetTaskStatus(params) {
      let data = new RestNewFollowupCallCenterServiceUpdatePhoneNumberCallState();
      for (var keys in params) {
        data['p_' + keys] = params[keys]
        data.p_nowUserId = sessionStorage.getItem('userid')
      }
      await data.send();
      console.log('result', data.result);
      return data.result;
    },
    //第一次保存呼叫记录
    async firstUpdatePhoneNumberCallState(contactId, p) {
      let request = new RestNewFollowupCallCenterServiceFirstUpdatePhoneNumberCallState()
      request.p_contactId = contactId
      request.p_callPlatform = this.seatType
      request.p_userId = p.userId
      request.p_nowUserId = sessionStorage.getItem('userid')
      request.p_patientId = p.patientId
      request.p_followupPatientId = p.followupPatientId
      request.p_followupTaskId = p.followupTaskId
      request.p_taskId = p.followupTaskId
      request.p_followUpPatientInfoId = p.followUpPatientInfoId
      request.p_phoneNumberId = p.phoneNumberId
      request.p_phoneNumber = p.phoneNumber
      request.p_callingPhoneNumber = p.callingPhoneNumber
      await request.send()
      return request.result
    },
    // 获取 关系列表
    async asyncGetReationShip() {
      let data = new RestCallCenterServiceGetAllRelationship();
      await data.send();
      return data.result;
    },
    // 发送短信
    async asyncSendMessage(params) {
      let data = new RestNewFollowupCallCenterServiceSendingFollowupSmsTask();
      data.p_phoneNumberList = params.phoneNumbers || []
      data.p_userId = this.userid
      data.p_followupPatientId = this.patientData.followupPatientId;
      data.p_followUpTaskId = this.getTaskCenterId
      data.p_smsCode = this.selectSonSms.id ? this.selectSonSms.smsCode : this.smsSelect
      await data.send();
      return data.result;
    },
    async getSMSDtail(code) {
      let request = new RestNewFollowupCallCenterServiceGetSmsTemplateByCode()
      request.p_smsCode = code
      await request.send()
      // return request.result
      this.smsDetail = request.result.retValue.smsContent
      this.getSonSmsTemplateList(request.result.retValue.id)
    },

    /**
     * 手动拨号
     * @param callNumber
     * @param id
     */
    manualCall(callNumber, id, it) {
      // 获取号码情况
      // NORMAL: 正常
      // SHUTDOWN: 停机
      // POWER_OFF: 关机
      // NOT_EXIST: 空号
      // SUSPECTED_POWER_OFF: 疑似关机
      // BUSY: 忙
      // UNKNOWN: 未知
      this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetPhoneNumberStatus',
        params: {
          phoneNumber: callNumber
        }
      }).then(res => {
        if (res.status == 0) {
          const phoneStatus = res.retValue;
          console.log(phoneStatus)
          // 处理空号情况
          if (phoneStatus === 'NOT_EXIST') {
            this.$message({
              message: '当前号码是空号',
              type: 'error',
              duration: 4000,
            });
            this.callReturnId = null
            this.addAbnormalCallRecord(callNumber, id, it, 12)

            this.asyncSetTaskStatus({
              id: this.callReturnId || -1,
              userId: this.userid,
              patientId: this.patientId,
              phoneNumber: callNumber,
              phoneNumberId: id,
              contactName: it.contactName,
              callPlatform: this.seatType,
              followupPatientId: this.patientData.followupPatientId,
              followUpPatientInfoId: this.patientData.followUpPatientInfoId,
              followupTaskId: this.getTaskCenterId,
              followupSource: this.$route.query.followupSource || 1,
              callingPhoneNumber: localStorage.getItem('callingPhoneNumber'),

              callState: 12, // 空号
              contactStatus: 4, // 电话随访未成功----联系状态
              contactInformation: 18, // 无----联系情况
              contactId: this.concatIDBackUp || this.contactId || JSON.parse(localStorage.getItem('contactId')) || JSON.parse(window.sessionStorage.getItem('contactId')),
            }).then(() => {
              console.log("刷新电话列表")

              this.refreshCallList()
            })
            return;
          }

          // 处理关机情况
          if (phoneStatus === 'POWER_OFF' || phoneStatus === 'SUSPECTED_POWER_OFF') {
            this.$message({
              message: '当前号码已关机',
              type: 'error',
              duration: 4000,
            });
            this.callReturnId = null
            this.addAbnormalCallRecord(callNumber, id, it, 10)
            this.asyncSetTaskStatus({
              id: this.callReturnId || -1,
              userId: this.userid,
              patientId: this.patientId,
              callState: 10, // 关机
              contactStatus: 4, // 电话随访未成功
              contactInformation: 18, // 无
              phoneNumber: callNumber,
              phoneNumberId: id,
              contactName: it.contactName,
              callPlatform: this.seatType,
              followupPatientId: this.patientData.followupPatientId,
              followUpPatientInfoId: this.patientData.followUpPatientInfoId,
              followupTaskId: this.getTaskCenterId,
              followupSource: this.$route.query.followupSource || 1,
              callingPhoneNumber: localStorage.getItem('callingPhoneNumber'),
              contactId: this.concatIDBackUp || this.contactId || JSON.parse(localStorage.getItem('contactId')) || JSON.parse(window.sessionStorage.getItem('contactId')),
            }).then(() => {
              this.refreshCallList()
            })
            return;
          }

          // 处理停机情况
          if (phoneStatus === 'SHUTDOWN') {
            this.$message({
              message: '当前号码已停机',
              type: 'error',
              duration: 4000,
            });
            this.callReturnId = null

            this.addAbnormalCallRecord(callNumber, id, it, 9)
            this.asyncSetTaskStatus({
              id: this.callReturnId || -1,
              userId: this.userid,
              patientId: this.patientId,
              callState: 9, // 停机
              contactStatus: 4, // 联系状态：电话随访未成功
              contactInformation: 18, // 联系情况
              phoneNumber: callNumber,
              phoneNumberId: id,
              contactName: it.contactName,
              callPlatform: this.seatType,
              followupPatientId: this.patientData.followupPatientId,
              followUpPatientInfoId: this.patientData.followUpPatientInfoId,
              followupTaskId: this.getTaskCenterId,
              followupSource: this.$route.query.followupSource || 1,
              callingPhoneNumber: localStorage.getItem('callingPhoneNumber'),
              contactId: this.concatIDBackUp || this.contactId || JSON.parse(localStorage.getItem('contactId')) || JSON.parse(window.sessionStorage.getItem('contactId')),
            }).then(() => {
              this.refreshCallList()
            })
            return;
          }


          if (this.seatType == 2) {
            this.takeCallHuawei(callNumber, id, it)
          } else {
            this.takeCallAliyun(callNumber, id, it)
          }
          // this.$emit('manualCall')
        }
      })

    },

    addAbnormalCallRecord(callNumber, id, it, callState) {
      this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceAddPhoneNumberStateAbnormalCallRecord',
        params: {
          userId: this.userid,
          patientId: this.patientId,
          followupPatientId: this.patientData.followupPatientId,
          followUpPatientInfoId: this.patientData.followUpPatientInfoId,
          followUpTaskId: this.getTaskCenterId,
          phoneNumberId: id,
          phoneNumber: callNumber,
          contactId: this.concatIDBackUp || this.contactId || JSON.parse(localStorage.getItem('contactId')) || JSON.parse(window.sessionStorage.getItem('contactId')),
          callingPhoneNumber: null,
          callState: callState, // 空号停机关机状态
          contactStatus: 4,
          contactInformation: 18,
        }
      }).then(res => {
      })
    },
    takeCallAliyun(callNumber, id, it) {
      this.hangupDisabled = true
      console.log(it);
      this.currentRelationPatientInfo = it;
      if (this.$route.query.aliLogin) {
        this.$message.error('当前状态不能拨打电话')
        return false
      }
      if (window.workbench.getStatusCode().code == 1 || window.workbench.getStatusCode().code == 0) {
        this.$alert('请点击下方重新登录阿里云按钮重新登录账号，并等待看到提示“可拨号”后才能进行后续拨打电话操作', '状态异常', {
          confirmButtonText: '重新登录阿里云',
          callback: action => {
            window.workbench.logIn()
          }
        });
        return false
      }
      this.checkSubmitStatus(callNumber)
        .then(res => {
          if (res) {
            if (this.isCalling) {
              return
            }
            console.log(11111);
            this.setNextCallNumber({ nextCallNumber: callNumber, nextCallNumberId: id });
            this.callingNumber = {
              number: callNumber,
              id: id
            }
            this.isCalling = true
            console.log(window.workbench);
            console.log("电话前状态=====》", window.workbench.getStatusCode());
            if (window.workbench.getStatusCode().code == -1) {
              console.log('未注册');
            }
            window.workbench.call(callNumber, this.calleePhoneNumber, null, false);
            this.setCurrentCallNumber({ currentCallNumber: callNumber, currentCallNumberId: id })
            this.setCurrentCalling(true)
            // this.beforeCall()
            //     .then((res) => {
            //       if (res) {
            //         // this.getFollowupPatientRecordList(it)
            //         this.setCallingStatus()
            //         window.pubsub && window.pubsub.emit('calling');
            //       } else {
            //         this.$message.error('缺少contractId')
            //       }
            //     })
          } else {
            return
          }
        })
    },
    takeCallHuawei(callNumber, id, it) {
      this.currentRelationPatientInfo = it;
      this.checkSubmitStatus(callNumber)
        .then(res => {
          if (res) {
            if (this.huaweiCalling) {
              return
            }
            this.setNextCallNumber({ nextCallNumber: callNumber, nextCallNumberId: id });
            this.callingNumber = {
              number: callNumber,
              id: id
            }
            this.setCurrentCallNumber({ currentCallNumber: callNumber, currentCallNumberId: id })
            this.setCurrentCalling(true)
            this.$store.dispatch('requestHandler', {
              fn: 'RestHuaWeiCECControllerCreateHuaWeiTwoCall',
              params: {
                userName: this.username,
                phone: callNumber
              }
            }).then(res => {
              console.log(res);
              this.huaweiId = {
                jobId: res.retValue
              }
              this.setContactId(this.huaweiId);
              this.concatIDBackUp = this.huaweiId
              localStorage.setItem('concatID', JSON.stringify(this.huaweiId))
              this.huaweiCalling = true
              this.beforeCallHuawei()
            })
            // console.log(window.workbench);
            // console.log("电话前状态=====》", window.workbench.getStatusCode());
            // if (window.workbench.getStatusCode().code == -1) {
            //   console.log('未注册');
            // }
            // window.workbench.call(callNumber, this.calleePhoneNumber, null, false);

          } else {
            return
          }
        })

    },
    manualCallBack(callNumber) {
      this.answerType = 2
      let id = this.patientList.find(item => item.phoneNumber == callNumber).id
      console.log(callNumber, this.patientList.find(item => item.phoneNumber == callNumber), id)
      this.setNextCallNumber({ nextCallNumber: callNumber, nextCallNumberId: id });
      this.isCalling = true
      setTimeout(() => {
        this.setCurrentCallNumber({ currentCallNumber: callNumber, currentCallNumberId: id })
        this.setCurrentCalling(true)
        this.$emit('manualCall')
      }, 1000)
    },

    confirmEditHandler(info, type) {
      console.log('info', info);
      if (type == 'update') { //编辑弹框
        info.phoneNumber = info.code ? `${info.code}-${info.phoneNumber}` : info.phoneNumber
      }
      // return 
      let params = {
        updateType: 1,
        id: info.id || null,
        patientId: this.patientId,
        phoneNumber: info.phoneNumber,
        relationshipName: info.relationshipName,
        contactName: info.contactName,
        phoneType: info.phoneType,
        relationshipLevelId: info.relationshipLevelId,
        relationshipLevel: info.relationshipLevel,
        cooperateScore: info.cooperateScore,
        lastCallState: info.lastCallState || null
      };
      this.asyncGetFollowupPatientContactInformation(params).then(res => {
        if (res.retValue.length > 0) {
          params.callDate = res.retValue[0].copyLastCallTime
          this.updateContactInfoAsync(params, true).then((data) => {
            if (data.status == 0) {
              // 更新用户 列表 TODO
              // this.patientList.forEach((v, i) => {
              //   if (v.id == params.id) {
              //     v.relationshipName = params.relationshipName;
              //     v.cooperateScore = params.cooperateScore
              //     v.contactName = params.contactName
              //     v.relationshipName = params.relationshipName
              //     v.lastCallState = params.lastCallState
              //   }
              // })
              this.successHandle({ message: "编辑成功" })
              this.$emit('refreshConcatInfo', this.patientId)
              this.editDialogVisible = false;
            } else {
              this.errorHandle(data)
            }
          })
        }
      })

    },
    async updateContactInfoAsync(p, b) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceUpdateFollowupPatientContactInformation',
        params: {
          nowUserId: sessionStorage.getItem('userid'),
          id: p.id,
          patientId: p.patientId,
          phoneNumber: p.phoneNumber,
          relationshipName: p.relationshipName,
          lastCallState: p.lastCallState,
          taskId: this.getTaskCenterId,
          callDate: p.callDate,
          updateType: 1,
          contactName: p.contactName,
          phoneType: p.phoneType,
          // relationshipLevelId: p.relationshipLevelId,
          relationshipLevel: p.relationshipLevel,
          cooperateScore: p.cooperateScore,
          isIdentifyBelongAddress: b,
        }
      })
      return result
    },
  }
}
</script>
<style lang="scss">
*::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

*::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #61aafa;
}

*::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}

.call-status-btn-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .phone-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 20px;
    color: #000;

    .status-options {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      margin: 10px 0;
    }

    .status-item {
      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        border-color: #dcdfe6 !important;
        color: #999 !important;
      }
    }

    .status-item {
      padding: 8px 15px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        border-color: #409eff;
      }

      &.active {
        border-color: #409eff;
        color: #409eff;
      }
    }
  }
}

.sms-record-dialog {
  .el-dialog__body {
    max-height: 500px;
    overflow: auto;
  }
}

.sms-record-table.el-table--fit {
  border-right: 1px solid #ebeef5;
}

.sms-record-table {
  width: 100%;
  border: 1px solid #ebeef5;
  border-bottom: none;
  color: rgb(145, 149, 156);

  th.el-table__cell>.cell {
    font-weight: bold;
    color: rgb(145, 149, 156);
  }

  td.el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    color: rgb(145, 149, 156);
  }

  .el-icon-success {
    cursor: auto;
  }
}
</style>
<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.bd {
  border: 1px solid transparent;
}

.error {
  border: 1px solid red;
}

@keyframes dot {
  0% {
    width: 0em;
    margin-right: 1.5em;
  }

  33% {
    width: 0.5em;
    margin-right: 1em;
  }

  66% {
    width: 0.8em;
    margin-right: 1.1em;
  }

  100% {
    width: 1.5em;
    margin-right: 0em;
  }
}

.audio-container {
  position: relative;
  padding: 15px;

  .close {
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
    font-weight: 700;
  }
}

.page-container {
  width: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08), 0px 1px 4px 0px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  /*margin-top: 20px;*/
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  &>.header {
    padding: 6px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(216, 216, 216, 1);
    width: 100%;

    &>span {
      display: inline-block;
      color: #000000;
      font-weight: 600;
      font-size: 16px;
    }

    .el-button {
      padding: 5px 10px;
      font-size: 15px;
      font-weight: 600;

      &:before {
        margin-right: 5px;
      }
    }
  }

  .call-item {
    .btn {
      margin-left: 15px;
    }

    .hang-up {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .callStatus {
        margin: 0 15px;

        &.calling {
          color: #248cfa;
        }

        &.connect {
          color: #0b8235;
        }
      }
    }
  }

  &>.user-list {
    max-height: calc(100vh - 60px - 60px - 629px);
    min-height: 180px;
    overflow: auto;

    .lastCall {
      .user_tel_box {
        background-color: rgba(245, 222, 179, 1);
      }
    }

    .phoneList {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      line-height: 28px;
      padding: 10px;
      border-bottom: 1px solid #ccc;

      .audio-list {
        width: 100%;
        text-align: left;

        .audio-list-item {
          padding-right: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          span,
          div {
            color: #666;
            font-size: 12px;
          }
        }
      }

      .user_tel_box {

        &:hover,
        &:active {
          background: rgba(245, 222, 179, 0.4);
        }
      }

      &>div:nth-of-type(1) {
        cursor: pointer;
        width: 100%;
        text-align: left;
        display: flex;

      }

      .user_tel_base {
        width: 100%;
        display: flex;
        align-items: center;

        span {
          margin-right: 6px;
          font-size: 16px;
        }

        .tel_relation {
          font-size: 14px;
          width: 20%;
          min-width: 57px;
          text-align: left;
        }

        .phone-number {
          font-size: 12px;
        }

        .category {
          &-radio-group {
            display: flex;
            flex-direction: column;
          }

          &-item {
            display: flex;

            &-text {
              width: 60%;
              line-height: 28px;
            }
          }
        }

      }

      .user-tel-state {
        width: 30%;
        min-width: 90px;
        line-height: 28px;
        display: flex;
        justify-content: flex-end;

        .icon-span {
          display: inline-block;
          width: 15%;
          margin: 0 10px;
          display: flex;
          align-items: center;

          img {
            width: 100%;
          }
        }

        .el-icon-edit-outline,
        .el-icon-phone,
        .el-icon-service,
        .el-icon-microphone {
          width: 30px;
          height: 30px;

          &:before {
            font-size: 22px;
          }
        }

        .el-icon-phone,
        .el-icon-service {
          margin-left: 8px;

          &:before {
            font-size: 22px;
            color: #248cfa;
          }
        }

        .calling-color {
          margin-right: 10px;
        }
      }

    }

    .message-list {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 20px;

      &>.el-checkbox {
        margin-top: 10px;
        margin-left: 20px;
        font-size: 16px;

      }
    }
  }

  .phone_edit_span {
    font-size: 16px;
    margin: 0 5px;
    padding: 5px;
  }

  .phone_edit_span:hover {
    cursor: pointer;
  }

  .contact_info_item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    &>div {
      margin-right: 8px;
    }
  }

  .phone-button {
    width: 280px;
    display: flex;
    justify-content: space-between;
    margin-right: 15px;

    .icon-addConnect {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-left: 10px;
      cursor: pointer;

      i {

        /*width: 33%;*/
        img {
          width: 100%;
        }
      }

      span {
        font-size: 12px;
        color: #248cfa;
      }
    }

    .select-message {
      width: 150px;
      display: flex;
      align-items: center;

      .el-select {
        width: 100% !important;
      }
    }

    .el-icon-circle-plus-outline,
    .el-icon-s-promotion {
      &:before {
        font-size: 18px;
      }
    }
  }
}
</style>
<style lang="scss">
.category {
  &-radio-group {
    .category-item {
      display: grid;
      grid-template-columns: 30px 150px 30px;
      grid-column-gap: 10px;

      &-text {
        line-height: 28px;
      }
    }

    .el-radio {
      margin-right: 8px;
      margin-bottom: 10px;
      width: 99%;

      .el-radio__label {
        width: 100%;
        padding: 0;
      }
    }

    .el-radio__input {
      display: none;
    }

    .el-radio__label {
      padding: 0 15px;
      width: 100%;
    }

    .el-radio__input.is-checked+.el-radio__label {
      color: #000;
    }
  }
}

.user-phoneNumber {
  .el-popover__reference {
    span {
      z-index: 999;
    }

    span:hover {
      border: 1px solid #248cfa !important;
      border-radius: 4px;
    }
  }
}

.dialog-item {
  display: flex;
  margin-bottom: 15px;
}
</style>
<style lang="scss">
// .edit-dialog {
//   .el-input {
//     width: 150px !important;
//     margin-right: 15px;

//   }
// }
.copy-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;

  >i {
    display: none;
  }

  &:hover {
    >i {
      display: inline-block;
      color: #bbb;
    }
  }

}
</style>